/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title pharmacyresultsselfservice.js: Feature level module
	 * @description The module used for displaying filters, drug networks and store location in bing map
	 * feature which encapsulates the CMPP Landing Results Page.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(98), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = function (linkMembership) {
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		var PharmacyResultSelfService = {
			/**
	      * The desktop Div ID
	      */
			desktopDivId: '#bing-map',
			/**
	   * Mobile Div ID
	   */
			mobileDivId: '#bing-map-mobile',
			/**
	   * Bing Map Zoom Configuration Value
	   */
			zoom: 11,
			/**
	   * Bing Map weight Configuration Value
	   */
			weight: 300,
			/**
	   * Stores Address Push
	   */
			setStoreAddressArr: [],
			/**
	      * Enter Keyword Code
	      */
			EnterKeywordCode: 13,
			/**
	      * Min Store Locations Visible
	      */
			minStoreLocationViewLength: 10,
			/**
	   * Drug Search Min. Length Configuration
	   */
			drugSearchMinLength: 1,
			/**
	      * Drug Search Max. Length Configuration
	      */
			drugSearchMaxLength: 2,
			/**
	      * brandSelection declaration
	      */
			brandSelection: 0,
			/**
	      * formSelection declaration
	      */
			formSelection: 0,
			/**
	      * strengthSelection declaration
	      */
			strengthSelection: 0,
			/**
	      * packageSelection declaration
	      */
			packageSelection: 0,
			/**
	      * quantitySelection declaration
	      */
			quantitySelection: 0,
			/**
	      * dataSet declaration
	      */
			dataSet: "",
			/**
	      * drugBrandParam declaration
	      */
			drugBrandParam: "",
	
			/**
	      * drugGenericBrandParam declaration
	      */
			drugGenericBrandParam: "",
			/**
	      * drugFormParam declaration
	      */
			drugFormParam: "",
			/**
	      * drugAdditionalInformationPre declaration
	      */
			drugAdditionalInformationPre: "",
			/**
	      * drugAdditionalInformationDrugName declaration
	      */
			drugAdditionalInformationDrugName: "",
			/**
	      * drugAdditionalInformationDrugNameModal declaration
	      */
			drugAdditionalInformationDrugNameModal: "",
			/**
	      * drugAdditionalInformationPost declaration
	      */
			drugAdditionalInformationPost: "",
			/**
	      * currentH1BrandName declaration
	      */
			currentH1BrandName: "",
			/**
	      * drugStrengthParam declaration
	      */
			drugStrengthParam: "",
			/**
	      * drugPackageParam declaration
	      */
			drugPackageParam: "",
			/**
	      * drugQuantityParam declaration
	      */
			drugQuantityParam: "",
			/**
	      * drugPackageOrFormParam declaration
	      */
			drugPackageOrFormParam: "",
			/**
	      * changeBrandParam declaration
	      */
			changeBrandParam: false,
			/**
	      * changeFormParam declaration
	      */
			changeFormParam: false,
			/**
	      * changeStrengthParam declaration
	      */
			changeStrengthParam: false,
			/**
	      * changePackageParam declaration
	      */
			changePackageParam: false,
			/**
	      * changeQuantityParam declaration
	      */
			changeQuantityParam: false,
			/**
	      * showPackageIndicatorParam declaration
	      */
			showPackageIndicatorParam: false,
			/**
	      * isFreshSearch declaration
	      */
			isFreshSearch: false,
			/**
	      * drugIdentifier declaration
	      */
			drugIdentifier: "",
			/**
	      * drugName declaration
	      */
			drugName: "",
			/**
	      * zipCode declaration
	      */
			zipCode: "",
			/**
	      * firstMarketingContentIndex declaration
	      */
			firstMarketingContentIndex: 0,
			/**
	      * secondMarketingContentIndex declaration
	      */
			secondMarketingContentIndex: 5,
			/**
	      * secondMarketingContentIndex declaration
	      */
			drugNDCIDParam: "",
			/* Adding Social SHARE Link popover, similar to the one in PDP*/
			pop_overs: function pop_overs() {
				$('.co-info').popover({
					container: '.math-table'
				});
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					COSTCO.util.socialNetworksPopover('social-share-link');
				}
			},
			getDrugDetailsByIdentifierAuthDetails: function getDrugDetailsByIdentifierAuthDetails() {
				var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_DETAILS_BY_DRUG_IDENTIFIER_END_POINT';
				var apiURL = '';
				var token = '';
				var displayError = '';
				var responseTimeout = 0;
				$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
					$('#cmppDrugNameTextID').val("");
					var object = JSON.parse(data);
					apiURL = object.apiURL;
					token = object.token;
					responseTimeout = object.responseTimeout;
					var drugIdentifier = PharmacyResultSelfService.getUrlParameter('drugIdentifierParam');
					var useSelectedNDCAsDefaultParameter = PharmacyResultSelfService.getUrlParameter('useSelectedNDCAsDefault');
					if (useSelectedNDCAsDefaultParameter != undefined && useSelectedNDCAsDefaultParameter.toLowerCase() == 'true') {
						useSelectedNDCAsDefaultParameter = '?useSelectedNDCAsDefault=true';
					} else {
						useSelectedNDCAsDefaultParameter = '';
					}
					$('#div_DrugNetworkResultsDisplay').addClass('ajax-busy');
					$('#div_DrugNetworkResultsDisplay .cmpp-loader').show();
					jQuery.ajax({
						url: apiURL + drugIdentifier + useSelectedNDCAsDefaultParameter,
						type: 'GET',
						timeout: responseTimeout,
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							'api-version': object.apiVersionNumber
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + token);
						},
						success: function success(response) {
							PharmacyResultSelfService.getDrugDetailsByDrugIdentifier(response);
							$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
							$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							console.log("Ajax Error>>" + thrownError);
							$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
							$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
						}
					});
				});
			},
			/**
	   * 
	   */
			getDrugDetailsByDrugIdentifier: function getDrugDetailsByDrugIdentifier(data) {
				// populateBrands
				PharmacyResultSelfService.dataSet = data;
				PharmacyResultSelfService.populateBrands();
				$("#filter_brand").on("change", PharmacyResultSelfService.changeBrand);
				$("#filter_form").on("change", PharmacyResultSelfService.changeForm);
				$("#filter_strength").on("change", PharmacyResultSelfService.changeStrength);
				$("#filter_package").on("change", PharmacyResultSelfService.changePackage);
				$("#filter_quantity").on("change", PharmacyResultSelfService.changeQuantity);
				$("#cmpp_tabs").show();
				PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails();
				$('#filter_brand option').each(function () {
					var text = $(this).text();
					if (text.length > 12 && $(window).width() < 952 && $(window).width() > 769) {
						text = text.substring(0, 9) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 856 && $(window).width() > 769) {
						text = text.substring(0, 9) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 1210 && $(window).width() > 1088) {
						text = text.substring(0, 27) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 1087 && $(window).width() > 1026) {
						text = text.substring(0, 22) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 1025 && $(window).width() > 857) {
						text = text.substring(0, 18) + '...';
						$(this).text(text);
					}
				});
			},
	
			getUrlParameter: function getUrlParameter(sParam) {
				var sPageURL = decodeURIComponent(window.location.search.substring(1));
				var sURLVariables = sPageURL.split('&');
				for (var i = 0; i < sURLVariables.length; i++) {
					var sParameterName = sURLVariables[i].split('=');
					if (sParameterName[0] === sParam) {
						return sParameterName[1] === undefined ? true : sParameterName[1];
					}
				}
			},
	
			changeQuantity: function changeQuantity(item) {
				PharmacyResultSelfService.changeQuantityParam = true;
				PharmacyResultSelfService.changeBrandParam = false;
				PharmacyResultSelfService.changeStrengthParam = false;
				PharmacyResultSelfService.changeFormParam = false;
				PharmacyResultSelfService.changePackageParam = false;
	
				PharmacyResultSelfService.drugQuantityParam = $(this).children("option:selected").val();
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
			},
	
			changeBrand: function changeBrand(item) {
				PharmacyResultSelfService.changeBrandParam = true;
				PharmacyResultSelfService.changeStrengthParam = false;
				PharmacyResultSelfService.changeFormParam = false;
				PharmacyResultSelfService.changePackageParam = false;
				PharmacyResultSelfService.changeQuantityParam = false;
	
				var index = $(this).children("option:selected").attr("data-index");
				PharmacyResultSelfService.brandSelection = index;
				PharmacyResultSelfService.drugBrandParam = $(this).children("option:selected").val();
				PharmacyResultSelfService.populateBrands();
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
				$('#filter_brand option').each(function () {
					var text = $(this).text();
					if (text.length > 12 && $(window).width() < 952 && $(window).width() > 769) {
						text = text.substring(0, 9) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 856 && $(window).width() > 769) {
						text = text.substring(0, 9) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 1210 && $(window).width() > 1088) {
						text = text.substring(0, 27) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 1087 && $(window).width() > 1026) {
						text = text.substring(0, 22) + '...';
						$(this).text(text);
					}
					if (text.length > 28 && $(window).width() < 1025 && $(window).width() > 857) {
						text = text.substring(0, 18) + '...';
						$(this).text(text);
					}
				});
			},
	
			changeForm: function changeForm(item) {
				PharmacyResultSelfService.changeFormParam = true;
				PharmacyResultSelfService.changeBrandParam = false;
				PharmacyResultSelfService.changeStrengthParam = false;
				PharmacyResultSelfService.changePackageParam = false;
				PharmacyResultSelfService.changeQuantityParam = false;
	
				var index = $(this).children("option:selected").attr("data-index");
				PharmacyResultSelfService.formSelection = index;
				PharmacyResultSelfService.populateForms();
				PharmacyResultSelfService.drugFormParam = $(this).children("option:selected").val();
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
			},
	
			changeStrength: function changeStrength(item) {
				PharmacyResultSelfService.changeStrengthParam = true;
				PharmacyResultSelfService.changeBrandParam = false;
				PharmacyResultSelfService.changeFormParam = false;
				PharmacyResultSelfService.changePackageParam = false;
				PharmacyResultSelfService.changeQuantityParam = false;
	
				var index = $(this).children("option:selected").attr("data-index");
				PharmacyResultSelfService.strengthSelection = index;
				PharmacyResultSelfService.populateStrengths();
				PharmacyResultSelfService.drugStrengthParam = $(this).children("option:selected").val();
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
			},
	
			changePackage: function changePackage(item) {
				PharmacyResultSelfService.changePackageParam = true;
				PharmacyResultSelfService.changeBrandParam = false;
				PharmacyResultSelfService.changeStrengthParam = false;
				PharmacyResultSelfService.changeFormParam = false;
				PharmacyResultSelfService.changeQuantityParam = false;
	
				var index = $(this).children("option:selected").attr("data-index");
				PharmacyResultSelfService.packageSelection = index;
	
				PharmacyResultSelfService.drugPackageParam = $(this).children("option:selected").val();
				PharmacyResultSelfService.showPackageIndicatorParam = $(this).children("option:selected").attr("data-packageIndicator");
				PharmacyResultSelfService.drugNDCIDParam = $(this).children("option:selected").attr("data-optionNDCVal");
	
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
			},
	
			populateBrands: function populateBrands() {
				$("#filter_brand").empty();
				var isPricesDisplayedInfoDone = false;
				PharmacyResultSelfService.drugAdditionalInformationPre = "";
				PharmacyResultSelfService.drugAdditionalInformationDrugName = "";
				PharmacyResultSelfService.drugAdditionalInformationPost = "";
				var brandCount = 0;
				PharmacyResultSelfService.dataSet.items.forEach(PharmacyResultSelfService.populateBrand);
	
				for (var i = 0; i < PharmacyResultSelfService.dataSet.items.length; i++) {
					var item = PharmacyResultSelfService.dataSet.items[i];
	
					if (item.drugType == "BRAND") {
	
						if (isPricesDisplayedInfoDone === false) {
							PharmacyResultSelfService.drugAdditionalInformationPre = "Prices displayed are for ";
							PharmacyResultSelfService.drugAdditionalInformationDrugName = PharmacyResultSelfService.drugBrandParam;
							PharmacyResultSelfService.drugAdditionalInformationDrugNameModal = PharmacyResultSelfService.drugBrandParam;
							PharmacyResultSelfService.drugAdditionalInformationPost = "";
							isPricesDisplayedInfoDone = true;
						}
	
						if (PharmacyResultSelfService.drugBrandParam.includes("GENERIC") || PharmacyResultSelfService.drugBrandParam.includes(" (Generic)")) {
							PharmacyResultSelfService.drugAdditionalInformationPost += brandCount == 0 ? ". Generic of " + item.drugName : ", " + item.drugName;
						}
	
						brandCount++;
					} else if (item.drugType == "GENERIC" && (!PharmacyResultSelfService.currentH1BrandName || PharmacyResultSelfService.currentH1BrandName === '')) {
						PharmacyResultSelfService.currentH1BrandName = item.drugName;
					}
				}
	
				// Only a generic - no brand...
				if (brandCount == 0) {
					PharmacyResultSelfService.drugAdditionalInformationPre = "Prices displayed are for ";
					PharmacyResultSelfService.drugAdditionalInformationDrugName = PharmacyResultSelfService.drugBrandParam;
					PharmacyResultSelfService.drugAdditionalInformationDrugNameModal = PharmacyResultSelfService.drugBrandParam;
					isPricesDisplayedInfoDone = true;
				}
	
				// populateForms
				PharmacyResultSelfService.populateForms();
			},
	
			populateBrand: function populateBrand(item, index) {
				var drugNameStr = item.drugType == "GENERIC" ? item.drugName + " (Generic)" : item.drugName;
				if (index == PharmacyResultSelfService.brandSelection && PharmacyResultSelfService.changeBrandParam == false) {
					PharmacyResultSelfService.drugBrandParam = drugNameStr;
				}
				var remark_html = '';
				remark_html += COSTCO.util.tmpl('tmpl_brand_selection', {
					currentIndex: index,
					selectState: index == PharmacyResultSelfService.brandSelection ? "selected='selected'" : '',
					optionText: drugNameStr,
					optionValue: drugNameStr
				});
				$('#filter_brand').append(remark_html);
			},
	
			populateForms: function populateForms() {
				$("#filter_form").empty();
				PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms.forEach(PharmacyResultSelfService.populateForm);
				//populateStrength
				PharmacyResultSelfService.populateStrengths();
			},
	
			populateForm: function populateForm(item, index) {
				if (item.isDefault == true && PharmacyResultSelfService.changeFormParam == false) {
					PharmacyResultSelfService.formSelection = index;
					PharmacyResultSelfService.drugFormParam = item.form;
				}
				var remark_html = '';
				remark_html += COSTCO.util.tmpl('tmpl_form_selection', {
					selectState: index == PharmacyResultSelfService.formSelection ? "selected='selected'" : '',
					currentIndex: index,
					optionText: item.form,
					optionValue: item.form
				});
				$('#filter_form').append(remark_html);
			},
	
			populateStrengths: function populateStrengths() {
				$("#filter_strength").empty();
				$("#filter_strength").removeAttr("disabled");
				PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths.forEach(PharmacyResultSelfService.populateStrength);
				$("#filter_quantity").empty();
				$("#filter_package").empty();
				$("#filter_package").removeAttr("disabled");
				PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths[PharmacyResultSelfService.strengthSelection].packageDescriptions.forEach(PharmacyResultSelfService.populatePackage);
				PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths[PharmacyResultSelfService.strengthSelection].packageDescriptions.forEach(PharmacyResultSelfService.populateNDCId);
				PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths[PharmacyResultSelfService.strengthSelection].packageDescriptions[0].quantities.forEach(PharmacyResultSelfService.populateQuantity);
	
				$("#filter_strength")[0].options.length == 0 ? $("#filter_strength").attr("disabled", "disabled") : "";
				$("#filter_package")[0].options.length == 0 ? $("#filter_package").attr("disabled", "disabled") : "";
			},
	
			populateStrength: function populateStrength(item, index) {
				if (item.isDefault == true && PharmacyResultSelfService.changeStrengthParam == false) {
					PharmacyResultSelfService.strengthSelection = index;
					PharmacyResultSelfService.drugStrengthParam = item.strengthValue;
				}
				var remark_html = '';
				if (!/^ *$/.test(item.strengthValue)) {
					remark_html += COSTCO.util.tmpl('tmpl_strength_selection', {
						selectState: index == PharmacyResultSelfService.strengthSelection ? "selected='selected'" : '',
						currentIndex: index,
						optionText: item.strengthValue,
						optionValue: item.strengthValue
					});
				}
				$('#filter_strength').append(remark_html);
			},
	
			populatePackage: function populatePackage(item, index) {
	
				if (item.isDefault == true && PharmacyResultSelfService.changePackageParam == false) {
					PharmacyResultSelfService.packageSelection = index;
					PharmacyResultSelfService.drugPackageParam = item.packageDescription;
					PharmacyResultSelfService.showPackageIndicatorParam = item.showPackageIndicator;
					PharmacyResultSelfService.populateDrugPackageFormDescription();
					PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				}
				var optionValue = item.packageDescription;
				var optionText = item.packageDescription;
				var optionPackageIndicator = item.showPackageIndicator;
				var optionNDCVal = item.ndc;
	
				var remark_html = '';
				if (!/^ *$/.test(item.packageDescription)) {
					remark_html += COSTCO.util.tmpl('tmpl_package_selection', {
						selectState: index == PharmacyResultSelfService.packageSelection ? "selected='selected'" : '',
						currentIndex: index,
						optionText: optionText,
						optionPackageIndicator: optionPackageIndicator,
						optionNDCVal: optionNDCVal,
						optionValue: optionValue
					});
				}
				$('#filter_package').append(remark_html);
			},
	
			populateNDCId: function populateNDCId(item, index) {
				if ((item.isDefault == true || PharmacyResultSelfService.changeStrengthParam == true || PharmacyResultSelfService.changePackageParam == true || PharmacyResultSelfService.changeFormParam == true) && item.packageDescription === PharmacyResultSelfService.drugPackageParam) {
					PharmacyResultSelfService.drugNDCIDParam = item.ndc;
				}
			},
	
			populateQuantity: function populateQuantity(item, index) {
				if (item.isDefault == true && PharmacyResultSelfService.changeQuantityParam == false) {
					PharmacyResultSelfService.quantitySelection = index;
					PharmacyResultSelfService.drugQuantityParam = item.quantity;
					PharmacyResultSelfService.populateDrugPackageFormDescription();
					PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				}
				var optionValue = item.quantity;
				var optionText = item.quantity;
				var remark_html = '';
				remark_html += COSTCO.util.tmpl('tmpl_quantity_selection', {
					selectState: index == PharmacyResultSelfService.quantitySelection ? "selected='selected'" : '',
					currentIndex: index,
					optionText: optionText,
					optionValue: optionValue
				});
				$('#filter_quantity').append(remark_html);
			},
	
			populateDrugPackageFormDescription: function populateDrugPackageFormDescription() {
	
				if (PharmacyResultSelfService.showPackageIndicatorParam) {
					if (PharmacyResultSelfService.drugFormParam == 'Miscellaneous') {
						if ($.trim(PharmacyResultSelfService.drugStrengthParam) == '') {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugPackageParam;
						} else {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugPackageParam + ", " + PharmacyResultSelfService.drugStrengthParam;
						}
					} else {
						if ($.trim(PharmacyResultSelfService.drugStrengthParam) == '') {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugFormParam + ", " + PharmacyResultSelfService.drugPackageParam;
						} else {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugFormParam + ", " + PharmacyResultSelfService.drugPackageParam + ", " + PharmacyResultSelfService.drugStrengthParam;
						}
					}
				} else {
					if ((PharmacyResultSelfService.drugFormParam == 'Tablet' || PharmacyResultSelfService.drugFormParam == 'Capsule') && PharmacyResultSelfService.drugQuantityParam > 1) {
						if ($.trim(PharmacyResultSelfService.drugStrengthParam) == '') {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase() + "s";
						} else {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugStrengthParam + ", " + PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase() + "s";
						}
					} else {
						if ($.trim(PharmacyResultSelfService.drugStrengthParam) == '') {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase();
						} else {
							PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugStrengthParam + ", " + PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase();
						}
					}
				}
			},
	
			printDrugInformationInHeader: function printDrugInformationInHeader(divId, tmplId) {
	
				var h1BrandName = "";
	
				// Only change the H1 heading if this is a fresh/ new search or if the brand drop down has changed, 
				// else leave the heading as it is...
				if (PharmacyResultSelfService.getUrlParameter('drugNameParam') && PharmacyResultSelfService.isFreshSearch) {
					h1BrandName = PharmacyResultSelfService.getUrlParameter('drugNameParam').replaceAll('+', ' ');
					PharmacyResultSelfService.currentH1BrandName = h1BrandName;
					PharmacyResultSelfService.isFreshSearch = false;
					$('#cmppBreadcrumbDrugName').text(h1BrandName);
				} else if (PharmacyResultSelfService.changeBrandParam) {
					h1BrandName = PharmacyResultSelfService.drugBrandParam;
					PharmacyResultSelfService.currentH1BrandName = h1BrandName;
				} else {
					h1BrandName = PharmacyResultSelfService.currentH1BrandName;
				}
	
				// Where the drug name in the H1 and the drug name in the line below (PharmacyResultSelfService.drugAdditionalInformationDrugName) match
				// Then special rules apply...
				if (PharmacyResultSelfService.drugAdditionalInformationDrugName.toUpperCase().includes(h1BrandName.toUpperCase())) {
					PharmacyResultSelfService.drugAdditionalInformationPre = "";
					PharmacyResultSelfService.drugAdditionalInformationDrugName = "";
					if (PharmacyResultSelfService.drugAdditionalInformationPost.includes(". Generic of")) {
						PharmacyResultSelfService.drugAdditionalInformationPost = PharmacyResultSelfService.drugAdditionalInformationPost.substring(2);
					}
				}
	
				var remark_html = '';
				$('#' + divId).html(remark_html);
				remark_html += COSTCO.util.tmpl(tmplId, {
					drugForm: PharmacyResultSelfService.drugFormParam,
					drugGenericBrand: PharmacyResultSelfService.drugGenericBrandParam,
					drugAdditionalInformationPre: PharmacyResultSelfService.drugAdditionalInformationPre,
					drugAdditionalInformationDrugName: PharmacyResultSelfService.drugAdditionalInformationDrugName,
					drugAdditionalInformationPost: PharmacyResultSelfService.drugAdditionalInformationPost,
					drugStrength: PharmacyResultSelfService.drugStrengthParam,
					drugStrengthPackageOrForm: PharmacyResultSelfService.drugPackageOrFormParam,
					drugQuantity: PharmacyResultSelfService.drugQuantityParam,
					drugAdditionalInformationDrugNameModal: PharmacyResultSelfService.drugAdditionalInformationDrugNameModal
				});
				$('#' + divId).html(remark_html);
				$('#cmppDrugBrandTitle').text(h1BrandName);
			},
	
			/**
	   * getAutoSuggestedDrugAuthDetails is a method is used for getting the API End-Point and Token Information from the back-end.
	   * This method hit an external API for getting the auto suggested drug list for a keyword provided in the text field
	   * This method invokes a method getAutoSuggestedDrugNamesByKeyword to display the results
	   * Condition : If the character length is more than 2
	   * Ex: 'fl' >> Flovent HFA, Fluad etc..!
	   * @param : keyword
	   */
			getAutoSuggestedDrugAuthDetails: function getAutoSuggestedDrugAuthDetails(keyword) {
				var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_SEARCH_END_POINT';
				var apiURL = '';
				var token = '';
				var displayError = '';
				var responseTimeout = 0;
				$('#cmppDrugNameTextID').remove('error');
				$('.cmppAutoSuggest').hide();
				//Setting the empty data to the respective #div_drugNameAutoSuggestionsError before inserting the data
				$('#div_drugNameAutoSuggestionsError').html(displayError);
				$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
					var object = JSON.parse(data);
					apiURL = object.apiURL;
					token = object.token;
					responseTimeout = object.responseTimeout;
					jQuery.ajax({
						url: apiURL + keyword,
						type: 'GET',
						timeout: responseTimeout,
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							'api-version': object.apiVersionNumber
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + token);
						},
						success: function success(response) {
							if (response.length > 0) {
								PharmacyResultSelfService.getAutoSuggestedDrugNamesByKeyword(response);
							} else {
								$('#cmppDrugNameTextID').addClass('error');
								$('#div_drugNameAutoSuggestionsError').addClass('error');
								displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
								$('#div_drugNameAutoSuggestionsError').html(displayError);
								$('.cmppAutoSuggest').hide();
							}
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							console.log("Ajax Error>>" + thrownError);
						}
					});
				});
			},
	
			/**
	      * Displays suggested drug list by the keyword provided by the user in the search text field
	      */
			getAutoSuggestedDrugNamesByKeyword: function getAutoSuggestedDrugNamesByKeyword(data) {
				var displaySuggestedNames = '';
				var displayError = '';
				var errroText = '';
				$('#cmppDrugNameTextID').removeClass('error');
				$('.cmppAutoSuggest').hide();
				$('#div_drugNameAutoSuggestions').html(displaySuggestedNames);
				$('#div_drugNameAutoSuggestionsError').html(displayError);
				displaySuggestedNames = "<ul id='autoSuggestionsId'>";
				for (var i in data) {
					displaySuggestedNames += COSTCO.util.tmpl('templ_drug_names_suggestions_display', {
						drugId: data[i].drugIdentifier,
						drugName: data[i].drugName
					});
				}
				displaySuggestedNames = displaySuggestedNames + '</ul>';
				$('#div_drugNameAutoSuggestions').html(displaySuggestedNames);
				$('.cmppAutoSuggest').show();
				$("#cmppDrugNameTextID").keyup(function () {
					$('#drugNameParam').val($(this).val());
					$('#drugIdentifierParam').val($('ul#autoSuggestionsId li:first').attr('id'));
				});
				$('#autoSuggestionsId li').keyup(function (e) {
					if (e.keyCode == 13) {
						$('#drugNameParam').val($(this).text());
						$('#drugIdentifierParam').val($(this).attr('id'));
						$('#cmppDrugNameTextID').val($(this).text());
						$('.cmppAutoSuggest').hide();
						$('#cmppSubmitId').click();
					}
				});
				$('#autoSuggestionsId li.selected').keyup(function (e) {
					if (e.keyCode == 13) {
						$('#drugNameParam').val($(this).text());
						$('#drugIdentifierParam').val($(this).attr('id'));
						$('#cmppDrugNameTextID').val($(this).text());
						$('.cmppAutoSuggest').hide();
						$('#cmppSubmitId').click();
					}
				});
				$('#autoSuggestionsId li').click(function () {
					$('#drugNameParam').val($(this).text());
					$('#drugIdentifierParam').val($(this).attr('id'));
					$('#cmppDrugNameTextID').val($(this).text());
					$('.cmppAutoSuggest').hide();
					$('#cmppSubmitId').click();
				});
			},
	
			getDrugPriceDetailsByNDCNAuthDetails: function getDrugPriceDetailsByNDCNAuthDetails() {
				var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_PRICE_DETAILS_BY_PARAMS_END_POINT';
				var apiURL = '';
				var token = '';
				var responseTimeout = 0;
				var displayError = '';
				$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
					PharmacyResultSelfService.toggleDrugPricingAndSpecs('cmppPricingTab', 'cmppPricingDetails');
					var remark_html = '';
					remark_html = '<div class="pharmacy-result-container">';
					remark_html += COSTCO.util.tmpl('tmpl_ajax_loader', {});
					remark_html += '</div>';
					$('#div_DrugNetworkResultsDisplay').addClass('ajax-busy');
					$('#div_DrugNetworkResultsDisplay').html(remark_html);
					$('#div_DrugNetworkResultsDisplay .cmpp-loader').show();
					var object = JSON.parse(data);
					apiURL = object.apiURL;
					token = object.token;
					responseTimeout = object.responseTimeout;
					var drugIdentifier = PharmacyResultSelfService.getUrlParameter('drugIdentifierParam');
					var drugNdc = PharmacyResultSelfService.drugNDCIDParam;
					console.log('drugNdc: ' + drugNdc);
					jQuery.ajax({
						url: apiURL + PharmacyResultSelfService.drugNDCIDParam + '?quantity=' + PharmacyResultSelfService.drugQuantityParam + '&zipCode=' + PharmacyResultSelfService.zipCode,
						type: 'GET',
						timeout: responseTimeout,
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							'api-version': object.apiVersionNumber
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + token);
							if ($('#drug-details-info').length > 0) $('#div_DrugDetails').children().last().hide();
						},
						success: function success(response) {
	
							var isPetMed = false;
							response.items.forEach(function (item) {
								if (item.isPetMed === true) {
									isPetMed = true;
								}
							});
	
							PharmacyResultSelfService.getDrugPriceDetailsByNDCNParams(response);
							$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
							$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
	
							// So long as this is not pet medication then go ahead
							// and make the call to get drug information...
							// 
							if (isPetMed === false) {
								PharmacyResultSelfService.getDrugDetailsInfo(token, drugNdc);
								$("#cmppDrugSpecificationsTab").show();
							} else {
								$("#cmppDrugSpecificationsTab").hide();
							}
	
							if ($('.link-membership-pet-meds').length > 0) {
								COSTCO.LinkMembership.init();
							}
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							console.log("Ajax Error>>" + thrownError);
							$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
							$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
						}
					});
				});
			},
			/**
	   * Calling Elsevier service to get detal drug information
	   * @param {*} token 
	   * @param {*} nationalDrugCode 
	   */
			getDrugDetailsInfo: function getDrugDetailsInfo(token, nationalDrugCode) {
				var remark_html = '';
				remark_html = '<div class="pharmacy-result-container">';
				remark_html += COSTCO.util.tmpl('tmpl_ajax_loader', {});
				remark_html += '</div>';
				$('#div_DrugDetails').addClass('ajax-busy');
				$('#div_DrugDetails').html(remark_html);
				$('#div_DrugDetails .cmpp-loader').show();
				$.ajax({
					url: '/AjaxGetCMPPDrugInfoCmd' + '?action=' + token + '&drugIdentifier=' + nationalDrugCode,
					type: 'POST',
					dataType: 'json',
					success: function success(data, textStatus, xhr) {
						try {
							var drugInfoResponse = JSON.parse(data.drugInfoResponse);
							if (data["http reponse status code"] === "200" && drugInfoResponse) {
								//success process returns the result in a JSON object.
								remark_html = '';
								remark_html += COSTCO.util.tmpl('templ_drug_details_info_display', {
									descriptionHeader: drugInfoResponse["DescriptionHeader"],
									descriptionBody: drugInfoResponse["Description"],
									contraindicationsHeader: drugInfoResponse["ContraindicationsHeader"],
									contraindicationsBody: drugInfoResponse["Contraindications"],
									administrationHeader: drugInfoResponse["AdministrationHeader"],
									administrationBody: drugInfoResponse["Administration"],
									missedDoseHeader: drugInfoResponse["MissedDoseHeader"],
									missedDoseBody: drugInfoResponse["MissedDose"],
									interactionsHeader: drugInfoResponse["InteractionsHeader"],
									interactionsBody: drugInfoResponse["Interactions"],
									monitoringHeader: drugInfoResponse["MonitoringHeader"],
									monitoringBody: drugInfoResponse["Monitoring"],
									sideEffectsHeader: drugInfoResponse["SideEffectsHeader"],
									sideEffectsBody: drugInfoResponse["SideEffects"],
									storageHeader: drugInfoResponse["StorageHeader"],
									storageBody: drugInfoResponse["Storage"]
								});
								$('#div_DrugDetails').append(remark_html);
								$('#div_DrugDetails').removeClass('ajax-busy');
								$('#div_DrugDetails .cmpp-loader').hide();
								console.log('ELSEVIER - successfully retrieving info drug');
							} else {
								console.error('Error: ELSEVIER - retrieving info drug');
								$('#div_DrugDetails').removeClass('ajax-busy');
								$('#div_DrugDetails .cmpp-loader').hide();
							}
						} catch (e) {
							console.warn('Warning: ELSEVIER - retrieving info drug - no drug info');
							$('#div_DrugDetails').removeClass('ajax-busy');
							$('#div_DrugDetails .cmpp-loader').hide();
						}
					},
					failure: function failure(data, textStatus, xhr) {
						console.log("Ajax Error>>" + thrownError);
						$('#div_DrugDetails').removeClass('ajax-busy');
						$('#div_DrugDetails .cmpp-loader').hide();
					}
				});
			},
			/**
	      * Function is used to retrieve the price details and print in the widget
	      */
			getDrugPriceDetailsByNDCNParams: function getDrugPriceDetailsByNDCNParams(data) {
				var crossSellEspot = '';
				var remark_html = '';
				remark_html = '<div class="pharmacy-result-container">';
				remark_html += COSTCO.util.tmpl('tmpl_ajax_loader', {});
				var countOfNoPricesToDisplay = 0;
				if (data.items.length == 0) {
					remark_html += COSTCO.util.tmpl('templ_drug_price_details_hero_marketing_1_display_no_pharmacies', { noPharmaciesMsg: messages.CMPP_NO_PHARMACIES_AVAILABLE });
				}
				//loop to grab the number of items with networname including 'Costco'
				var crossSellEspotIndex = -1;
				for (var i in data.items) {
					if (data.items[i].networkName.includes('Costco')) {
						crossSellEspotIndex = crossSellEspotIndex + 1;
					}
				}
				for (var i in data.items) {
					var displayNetwork = true;
					if (data.items[i].networkName != messages.CMPP_COSTCO_MAIL_ORDER && data.items[i].mailOrderLocation === true) {
						displayNetwork = false;
					}
					if (i == PharmacyResultSelfService.firstMarketingContentIndex) {
						remark_html += COSTCO.util.tmpl('templ_drug_price_details_hero_marketing_1_display', {});
					}
					if (crossSellEspotIndex == -1) {
						// No network with Costco result - Cross sell Espot Should be displayed below the hero_marketing_epsot 
						remark_html += '<div class="cross-sell-espot-class" style="display:none;"></div>';
					}
					if (i == PharmacyResultSelfService.secondMarketingContentIndex) {
						remark_html += COSTCO.util.tmpl('templ_drug_price_details_hero_marketing_2_display', {});
					}
					if (displayNetwork) {
						if (typeof data.items[i].isPetMed === 'undefined' || data.items[i].isPetMed == false || data.items[i].isPetMed == true && data.items[i].showPrice == true) {
							//Insert commas into the numeric string at appropriate places to format it with thousands separators.
							var networkPrice = '$' + data.items[i].networkPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
							if (data.items[i].mailOrderLocation == true) {
								remark_html += COSTCO.util.tmpl('templ_drug_networks_get_started_results_display', {
									networkName: data.items[i].networkName,
									networkLogoURL: data.items[i].logoUrl + '?placeholderForMissingLogo=true',
									networkDrugPrice: data.items[i].isPetMed == true ? this.getDrugPriceTextForLoggedInUser('<h2>' + networkPrice + '</h2>') : '<h2>' + networkPrice + '</h2>',
									fromPage: encodeURIComponent(location.pathname),
									petMedPriceColumnWidth: data.items[i].isPetMed == true ? 'col-md-5 col-lg-5 col-xl-5' : 'col-md-4 col-lg-4 col-xl-4',
									petMedOnlineLinkColumnWidth: data.items[i].isPetMed == true ? 'col-md-3 col-lg-3 col-xl-3' : 'col-md-4 col-lg-4 col-xl-4'
								});
							} else {
								remark_html += COSTCO.util.tmpl('templ_drug_networks_results_display', {
									networkName: data.items[i].networkName,
									networkLogoURL: data.items[i].logoUrl + '?placeholderForMissingLogo=true',
									networkDrugPrice: data.items[i].isPetMed == true ? this.getDrugPriceTextForLoggedInUser('<h2>' + networkPrice + '</h2>') : '<h2>' + networkPrice + '</h2>',
									networkId: data.items[i].id,
									fromPage: encodeURIComponent(location.pathname),
									customURL: data.items[i].customURL,
									customURLText: data.items[i].customURLText,
									petMedPriceColumnWidth: data.items[i].isPetMed == true ? 'col-md-5 col-lg-5 col-xl-5' : 'col-md-4 col-lg-4 col-xl-4',
									petMedOnlineLinkColumnWidth: data.items[i].isPetMed == true ? 'col-md-3 col-lg-3 col-xl-3' : 'col-md-4 col-lg-4 col-xl-4'
								});
							}
						} else {
							if (data.items[i].mailOrderLocation == true) {
								if (typeof data.items[i].showAltPriceImage === 'undefined' || data.items[i].showAltPriceImage == false) {
									remark_html += COSTCO.util.tmpl('templ_drug_networks_get_started_results_petMedText_display', {
										networkName: data.items[i].networkName,
										networkLogoURL: data.items[i].logoUrl + '?placeholderForMissingLogo=true',
										networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceText),
										networkId: data.items[i].id,
										fromPage: encodeURIComponent(location.pathname)
									});
								} else {
									remark_html += COSTCO.util.tmpl('templ_drug_networks_get_started_results_petMedImage_display', {
										networkName: data.items[i].networkName,
										networkLogoURL: data.items[i].logoUrl + '?placeholderForMissingLogo=true',
										networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceImageUrl),
										networkId: data.items[i].id,
										fromPage: encodeURIComponent(location.pathname)
									});
								}
							} else {
								if (typeof data.items[i].showAltPriceImage === 'undefined' || data.items[i].showAltPriceImage == false) {
	
									remark_html += COSTCO.util.tmpl('templ_drug_networks_results_petMedText_display', {
										networkName: data.items[i].networkName,
										networkLogoURL: data.items[i].logoUrl + '?placeholderForMissingLogo=true',
										networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceText),
										networkId: data.items[i].id,
										fromPage: encodeURIComponent(location.pathname),
										customURL: data.items[i].isPetMed == true && data.items[i].showPrice == false && data.items[i].networkName == messages.CMPP_PETMED_NETWORK_VETSOURCE ? data.items[i].customURL : null,
										customURLText: data.items[i].isPetMed == true && data.items[i].showPrice == false && data.items[i].networkName == messages.CMPP_PETMED_NETWORK_VETSOURCE ? data.items[i].customURLText : null
									});
									countOfNoPricesToDisplay++;
								} else {
									remark_html += COSTCO.util.tmpl('templ_drug_networks_results_petMedImage_display', {
										networkName: data.items[i].networkName,
										networkLogoURL: data.items[i].logoUrl + '?placeholderForMissingLogo=true',
										networkDrugPriceURL: data.items[i].altPriceImageUrl,
										networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceImageUrl),
										networkId: data.items[i].id,
										fromPage: encodeURIComponent(location.pathname)
									});
								}
							}
						}
					}
					//  Network name has 1 or 2 Costco result, Cross sell Espot should be displayed below the Costco result
					if (i == crossSellEspotIndex && crossSellEspotIndex != -1) {
						remark_html += '<div class="cross-sell-espot-class" style="display:none;"></div>';
					}
				}
				PharmacyResultSelfService.readESPOT_By_NDCN(data);
				remark_html = remark_html + '</div>';
				$('#div_DrugNetworkResultsDisplay').html(remark_html);
	
				isPricingDataToDisplay = true;
	
				if (data.items.length == 0) {
					isPricingDataToDisplay = false;
				} else if (data.items.length == countOfNoPricesToDisplay) {
					isPricingDataToDisplay = false;
				}
	
				if (isPricingDataToDisplay == false) {
					PharmacyResultSelfService.drugAdditionalInformationPre = "";
					PharmacyResultSelfService.drugAdditionalInformationPost = "";
					PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header', 'tmpl_drug_selection_details_in_header');
				}
			},
			toggleDrugPricingAndSpecs: function toggleDrugPricingAndSpecs(buttonId, drugDetailsType) {
				var i, tabcontent, tablinks;
	
				tabcontent = $("#cmpp_tabs .tabcontent");
				for (i = 0; i < tabcontent.length; i++) {
					tabcontent[i].style.display = "none";
				}
	
				tablinks = $(".cmppTabs .tablinks");
				for (i = 0; i < tablinks.length; i++) {
					tablinks[i].className = tablinks[i].className.replace(" active", "");
					tablinks[i].ariaExpanded = "false";
				}
	
				$("#" + drugDetailsType).attr("style", "display:block;");
				$("#" + buttonId)[0].className += " active";
				$("#" + buttonId)[0].ariaExpanded = "true";
			},
	
			//Adding Espots to the CMPP Result page
			//Four different Espots needs to be displayed depending on the value from the response
			readESPOT_By_NDCN: function readESPOT_By_NDCN(data) {
				var espot1Name = '';
				var complianceEspot = '';
				var crossSellEspotName = '';
				var crossSellEspotValue = '';
				var espot3Name = '';
				var categoryEspot3 = '';
				var espot4Name = '';
				var categoryEspot4 = '';
				var responseData = '';
				if (data.espots != null) {
					if (data.espots.espot1) {
						complianceEspot = data.espots.espot1;
						espot1Name = "cmppPharmacy_".concat(complianceEspot);
					}
					if (data.espots.espot2) {
						crossSellEspotValue = data.espots.espot2;
						crossSellEspotName = "cmppPharmacy_".concat(crossSellEspotValue);
					}
					if (data.espots.espot3) {
						categoryEspot3 = data.espots.espot3;
						espot3Name = "cmppPharmacy_".concat(categoryEspot3);
					}
					if (data.espots.espot4) {
						categoryEspot4 = data.espots.espot4;
						espot4Name = "cmppPharmacy_".concat(categoryEspot4);
					}
					//Display Espots depending on the response 
					if (data.items.length !== 0) {
						jQuery.ajax({
							url: '/CostcoESpotApiRead?ems1Name=' + espot1Name + '&ems2Name=' + crossSellEspotName + '&ems3Name=' + espot3Name + '&ems4Name=' + espot4Name,
							type: 'GET',
							headers: { "Content-Type": "application/html", "Accept": "application/html" },
							success: function success(ESpotcontentstr) {
								var ESpotcontent = $.parseHTML(DOMPurify.sanitize(ESpotcontentstr)); // Changing the String Response to object
								var remark_html = '';
								var complianceEspotContent = '';
								var crossSellEspotContent = '';
								var categoryEspot3Content = '';
								var categoryEspot4Content = '';
								if (complianceEspot && typeof $(ESpotcontent).find('#ems1Content').html() !== 'undefined') {
									//Checks if Compliance message Espot has a value and Content.
									remark_html = '<div class="pharmacy-espot-container">';
									complianceEspotContent = $(ESpotcontent).find('#ems1Content').html();
									remark_html += complianceEspotContent;
									remark_html = remark_html + '</div>';
									$('#div_DrugNetworkEspotDisplay').html(remark_html);
								} else {
									$('#div_DrugNetworkEspotDisplay').hide();
								}
								if (crossSellEspotValue && typeof $(ESpotcontent).find('#ems2Content').html() !== 'undefined') {
									// Checks if Cross Sell Espot has a value and Content.
									crossSellEspotcontent = $(ESpotcontent).find('#ems2Content').html();
									$(".cross-sell-espot-class").html(crossSellEspotcontent);
									$(".cross-sell-espot-class").show();
								} else {
									$(".cross-sell-espot-class").hide();
								}
								if (categoryEspot3 && typeof $(ESpotcontent).find('#ems3Content').html() !== 'undefined') {
									// Checks if First Categories Espot has a value and Content.
									remark_html = '<div class="categories-espot-container">';
									categoryEspot3Content = $(ESpotcontent).find('#ems3Content').html();
									remark_html += categoryEspot3Content;
									remark_html = remark_html + '</div>';
									$('#div_DrugNetworkCategoriesEspot1').html(remark_html);
									$('#div_DrugNetworkCategoriesEspot1_mobile_view').html(remark_html);
								} else {
									$('#div_DrugNetworkCategoriesEspot1').hide('categories-espot');
									$('#div_DrugNetworkCategoriesEspot1_mobile_view').hide('categories-espot');
								}
								if (categoryEspot4 && typeof $(ESpotcontent).find('#ems4Content').html() !== 'undefined') {
									// Checks if Second Categories Espot has a value and Content.
									remark_html = '<div class="categories-espot-container">';
									categoryEspot4Content = $(ESpotcontent).find('#ems4Content').html();
									remark_html += categoryEspot4Content;
									remark_html = remark_html + '</div>';
									$('#div_DrugNetworkCategoriesEspot2').html(remark_html);
									$('#div_DrugNetworkCategoriesEspot2_mobile_view').html(remark_html);
								} else {
									$('#div_DrugNetworkCategoriesEspot2').hide('categories-espot');
									$('#div_DrugNetworkCategoriesEspot2_mobile_view').hide('categories-espot');
								}
							},
							error: function error(xhr, ajaxOptions, thrownError) {
								console.log("Espot error");
							}
						});
					}
				}
			},
	
			getDrugStoreLocationsDisplay: function getDrugStoreLocationsDisplay(byId) {
				PharmacyResultSelfService.clearTemplateView('bing-map');
				PharmacyResultSelfService.clearTemplateView('costcoModalBodyData');
				$('#ShowMore').hide();
				$('#warehouse-modal-spinner').html(COSTCO.util.tmpl('tmpl_spinner'));
				var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_STORE_LOCATIONS_BY_ID_END_POINT';
				var apiURL = '';
				var token = '';
				var displayError = '';
				var responseTimeout = 0;
				$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
					var object = JSON.parse(data);
					apiURL = object.apiURL;
					token = object.token;
					responseTimeout = object.responseTimeout;
					var drugIdentifier = PharmacyResultSelfService.getUrlParameter('drugIdentifierParam');
					jQuery.ajax({
						url: apiURL + byId + '?zipCode=' + PharmacyResultSelfService.zipCode,
						type: 'GET',
						timeout: responseTimeout,
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							'api-version': object.apiVersionNumber
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + token);
						},
						success: function success(response) {
							PharmacyResultSelfService.printDrugStoreLocationsDisplay(response);
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							$('#warehouse-modal-spinner').html('');
							console.log("Ajax Error>>" + thrownError);
						}
					});
				});
				$(document).ready(function () {
					setTimeout(function () {
						var mapLi = $('ul#costcoModalBodyData li').length;
						var mapLiVisible = $('ul#costcoModalBodyData li:visible').length;
						if (mapLi == mapLiVisible) {
							$('#ShowMore').hide();
						}
					}, 600);
				});
			},
	
			/**
	      * Function is used to retrieve the store location details and print in the pop-up on click View Locations link
	      */
			printDrugStoreLocationsDisplay: function printDrugStoreLocationsDisplay(data) {
				var remark_html = "";
				$('#warehouse-modal-spinner').html('');
				PharmacyResultSelfService.displayStoresOnMap(data.items);
				if (data.items.length > PharmacyResultSelfService.minStoreLocationViewLength) {
					$('#ShowMore').show();
				} else {
					$('#ShowMore').hide();
				}
				data.items.forEach(function (storeObj, i) {
					var newZip = PharmacyResultSelfService.truncateZip(storeObj.zip);
					var newMiles = storeObj.distance.toFixed(2);
					remark_html += COSTCO.util.tmpl('templ_drug_store_locations_results_display', {
						storeNumber: i + 1,
						id: storeObj.id,
						storeName: storeObj.storeName,
						address1: storeObj.address1,
						address2: storeObj.address2,
						city: storeObj.city,
						state: storeObj.state,
						zip: newZip,
						telephoneNumber: typeof storeObj.telephoneNumber !== "undefined" && storeObj.telephoneNumber.length === 10 ? "(".concat(storeObj.telephoneNumber.substring(0, 3)).concat(") ").concat(storeObj.telephoneNumber.substring(3, 6)).concat("-").concat(storeObj.telephoneNumber.substring(6, 10)) : "",
						hours: storeObj.hours,
						customAttribute1: storeObj.customAttribute1,
						customAttribute2: storeObj.customAttribute2,
						customAttribute3: storeObj.customAttribute3,
						distance: newMiles,
						setStoreCompleteAddress: PharmacyResultSelfService.setStoreAddress(storeObj.id, storeObj.address1, "", storeObj.city, storeObj.state)
					});
				});
				$('#costcoModalBodyData').html(remark_html);
				$('#costcoModalTitleLocations').text("Find a Location");
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_modal_header', 'tmpl_drug_selection_details_in_modal_header');
				PharmacyResultSelfService.focusOnModal();
			},
			/**
	   * Function whicch keep focus on modal
	   */
			focusOnModal: function focusOnModal() {
				$('#costcoModalLocations').keydown(function (e) {
					var $focusable = $(this).find("button, a, input").filter(":visible");
					if ($focusable.last().is(":focus") && !e.shiftKey && e.keyCode == 9) {
						e.preventDefault();
						$focusable.first().focus();
					} else if ($focusable.first().is(":focus") && e.shiftKey && e.keyCode == 9) {
						e.preventDefault();
						$focusable.last().focus();
					}
				});
			},
			/**
	      * Function is used to clear the content in the Div
	      */
			clearTemplateView: function clearTemplateView(divId) {
				var clearView = '';
				$('#' + divId).html(clearView);
			},
			/**
	      * Function is used to concat the address details and push the address
	      */
			setStoreAddress: function setStoreAddress(storeIdParam, strAdd1Param, strAdd2Param, strCityParam, strStateParam) {
				var storeAddress = '';
				storeAddress = encodeURIComponent([''].concat(strAdd1Param.split(' ')).concat(strAdd2Param.split(' ')).concat(strCityParam.split(' ')).concat(strStateParam).join(' '));
				PharmacyResultSelfService.setStoreAddressArr.push({
					Key: storeIdParam,
					Value: storeAddress
				});
			},
			/**
	      * Creates an instance of the BING map and stores it in the Locator object.
	      * @param  {string} mapId the BING map container id
	      * @return {void}
	      */
			displayStoresOnMap: function displayStoresOnMap(locationObjects) {
				try {
	
					/**
	     * Bing Map Secret Key
	     */
					var globalBingStaticKeyVar = $('#globalBingStaticKey').val();
	
					var map = new Microsoft.Maps.Map(PharmacyResultSelfService.desktopDivId, {
						credentials: globalBingStaticKeyVar,
						mapTypeId: Microsoft.Maps.MapTypeId.road,
						enableHighDpi: true,
						liteMode: true,
						zoom: PharmacyResultSelfService.zoom,
						navigationBarMode: Microsoft.Maps.NavigationBarMode.minified
					});
					var pins = [];
					locationObjects.forEach(function (locationObj, i) {
						var location = new Microsoft.Maps.Location(locationObj.latitude, locationObj.longitude);
						var pin = new Microsoft.Maps.Pushpin(location, {
							icon: COSTCO.util.tmpl('tmpl_locator_pin', {
								number: i + 1,
								weight: PharmacyResultSelfService.weight,
								locationName: location
							}),
							anchor: new Microsoft.Maps.Point(10.5185, 30)
						});
						pins.push(pin);
					});
					// Add the pins to the map
					map.entities.push(pins);
	
					if (locationObjects.length === 1) {
						//Use Center view to scale the map to default 2 miles using zoom = 11
						map.setView({
							center: new Microsoft.Maps.Location(locationObjects[0].latitude, locationObjects[0].longitude),
							zoom: PharmacyResultSelfService.zoom
						});
					} else {
						// Determine a bounding box to best view the results.
						var bounds = Microsoft.Maps.LocationRect.fromLocations(locationObjects);
						// Use the locations from the results to calculate a bounding box.
						map.setView({
							bounds: bounds
						});
					}
				} catch (e) {
					$(PharmacyResultSelfService.desktopDivId).html('<div tabindex="0" class="cds-u-space-pr-md cds-u-space-pl-md" style="height: 400px; background-color: #eeeeee;">' + '<span><p class="body-copy cds-u-space-pt-md">' + messages.COOKIE_COMPLIANCE_BING_WARNING_MESSAGE + '</p></span></div>');
				}
			},
			/**
	      * onclick handler for the "Get Directions" link. Opens a new tab and redirects
	      * to maps.google.com using Current Location as starting addr and warehouse
	      * address as the destination address.
	      * @param  {number} index used to get the store id
	      * @return {void}
	      */
			getStoreDirections: function getStoreDirections(index) {
				var storeLocation = '';
				PharmacyResultSelfService.setStoreAddressArr.forEach(function (storeAddress) {
					if (storeAddress.Key == index) {
						storeLocation = storeAddress.Value;
					}
				});
				var win = window.open(window.location.protocol + '//maps.google.com?saddr=Current+Location&daddr=' + storeLocation, '_blank');
				win.focus();
			},
			validateDrugForm: function validateDrugForm() {
				var isValid = true;
				var drugIdentifierVal = $('#drugIdentifierParam').val();
				if ($('#cmppDrugNameTextID').val() == "" || drugIdentifierVal == "" || typeof $('#' + drugIdentifierVal + '')[0] !== 'undefined' && $('#' + drugIdentifierVal + '').attr('aria-label').toLowerCase() !== $('#cmppDrugNameTextID').val().toLowerCase()) {
	
					return false;
				}
				return isValid;
			},
			/**
	   * Function used to identify CMPP feature is Dormant or not
	   */
			isCMPPDormant: function isCMPPDormant() {
				$.get('/AjaxCostcoCMPPDormantCheckLookupView').done(function (data) {
					try {
						var isCMPPDormantFlag = $.trim(data);
						return isCMPPDormantFlag;
					} catch (e) {
						return false;
					}
				});
			},
			/**
	   * Function used to display the error text in the widget
	   */
			displayErrorMessage: function displayErrorMessage(divId, errorTextParam) {
				var remark_html = '';
				remark_html += COSTCO.util.tmpl('tmpl_drug_error_display', {
					errorText: errorTextParam
				});
				$('#' + divId).append(remark_html);
			},
	
			openMap: function openMap() {
				$('#openCmppMap').hide();
				$('#bing-map').show();
				$('#closeCmppMap').show();
			},
			closeMap: function closeMap() {
				$('#openCmppMap').show();
				$('#bing-map').hide();
				$('#closeCmppMap').hide();
			},
			openFilter: function openFilter() {
				$('#Filter-Container').show();
				$('#openFilter').hide();
				$('#hideFilter').show();
			},
			hideFilter: function hideFilter() {
				$('#Filter-Container').hide();
				$('#openFilter').show();
				$('#hideFilter').hide();
			},
			truncateZip: function truncateZip(zip) {
				if (zip > 5) {
					return zip.substring(0, 5);
				} else {
					return zip;
				}
			},
			truncateMiles: function truncateMiles(miles) {
				if (miles > 5) {
					return miles.substring(0, 5);
				} else {
					return miles;
				}
			},
			checkCustomElement: function checkCustomElement(check) {
				if (check.length > 1) {
					return check;
				} else {
					return;
				}
			},
			mileTrunc: function mileTrunc(miles, fixed) {
				var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
				return miles.toString().match(re)[0];
			},
			openSearch: function openSearch() {
				$('#compare-price-container').show();
				$('#openSearchCMPP').hide();
			},
	
			/**
	   * Function that checks if the user is logged in and with active membership. It will return a link to the user
	   * to add the membership number. If user is not logged in at all it will return sign in link. 
	   * User needs to be signed in order to see the price for Pet Medications.
	   * */
			returnSignInForPriceHTML: function returnSignInForPriceHTML() {
				if (COSTCO.util.getMemberCookie().signedIn == true) {
					if (COSTCO.util.getMemberCookie().costcoMember == false || COSTCO.util.getMemberCookie().active == false) {
						return '<a class="link-membership-pet-meds" data-bi-tc="nav:CMPP | Add Membership Number to See Price" href="#" onclick="COSTCO.PharmacyResultSelfService.openLinkMembershipModal();return false;">' + messages.RWD_ADD_MEMBERSHIP_NUMBER_TO_SEE_PRICE + '</a>';
					}
				} else {
					return '<a data-bi-tc="nav:CMPP | Sign In to See Price" href="' + window.location.protocol + '//' + window.location.host + '/LogonForm?URL=' + encodeURIComponent(window.location.href) + '" > ' + messages.RWD_SIGN_IN_TO_SEE_PRICE_BC + ' </a>';
				}
			},
	
			/**
	   *  Function return provided price or alternative text from the (Cervey) service response. Can be reused for other purposes.
	   *  Return provided string based on state of the user. 
	   * */
			getDrugPriceTextForLoggedInUser: function getDrugPriceTextForLoggedInUser(drugPriceOrAlternativeText) {
				return this.isUserLoggedInWithActiveMembership() == true ? drugPriceOrAlternativeText : this.returnSignInForPriceHTML();
			},
	
			/**
	   * Checks for users member cookie whether user is logged in with valid membership number. Return true if is logged in and has membership that is active.  
	   * */
			isUserLoggedInWithActiveMembership: function isUserLoggedInWithActiveMembership() {
				return COSTCO.util.getMemberCookie().signedIn == true && COSTCO.util.getMemberCookie().costcoMember == true && COSTCO.util.getMemberCookie().active == true ? true : false;
			},
	
			openLinkMembershipModal: function openLinkMembershipModal() {
				var modalSettings = {
					dialogclasses: 'link-membership-modal',
					title: messages.RWD_ADD_MEMBERSHIP_NUMBER,
					body: COSTCO.util.tmpl('tmpl_membership_validation_pet_meds', {
						infoText: messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Body_PET_MEDS,
						membershipNumber: COSTCO.LinkMembership.memberData.number
					}),
	
					primary: messages.RWD_ADD_MEMBERSHIP_NUMBER,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: COSTCO.LinkMembership.performPrimaryValidation,
					preventClose: false,
					onshown: function onshown() {
						$('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
						COSTCO.util.maskMembershipInput();
						$('.co-help').popover();
						// Prevent default behavior for form - Send request to server, causing page to reload navigate to new url
						$(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID).submit(function (event) {
							event.preventDefault();
						});
					},
					onclose: function onclose() {}
				};
	
				COSTCO.dialog.showModal(modalSettings);
			}
		};
		function showMoreMap() {
			$('#ShowMore').show();
			setTimeout(function () {
				var mapLi = $('ul#costcoModalBodyData li').length;
				var mapLiVisible = $('ul#costcoModalBodyData li:visible').length;
				if (mapLi == mapLiVisible) {
					$('#ShowMore').hide();
				}
			}, 800);
		};
		window.COSTCO.PharmacyResultSelfService = PharmacyResultSelfService;
		$(document).ready(function () {
			if (PharmacyResultSelfService.isCMPPDormant()) {
				window.location.href = "Pharmacy/member-prescription-program.html";
			} else {
				//Check if the delivery postal container in the minibar is visible
				var invCheckPostalCode = $.cookie('invCheckPostalCode');
				PharmacyResultSelfService.zipCode = invCheckPostalCode;
				PharmacyResultSelfService.getDrugDetailsByIdentifierAuthDetails();
				PharmacyResultSelfService.pop_overs();
				PharmacyResultSelfService.isFreshSearch = true;
				$("#closeMap").hide();
				/**
	    * Invoke the method getAutoSuggestedDrugAuthDetails if the user type in the text field if the character length is more than min. length configuration
	    */
				$("#cmppDrugNameTextID, #cmppAutoSuggest").keyup(function (e) {
					var li = $('ul#autoSuggestionsId li');
					var liSelected = $('ul#autoSuggestionsId li.selected');
					if ((e.which === 40 || e.which === 38) && (event.which === 40 || event.which === 38)) {
						if (e.which === 40) {
							if (liSelected) {
								liSelected.removeClass('selected');
								next = liSelected.next();
								if (next.length > 0) {
									liSelected = next.addClass('selected').focus();
								} else {
									liSelected = li.eq(0).addClass('selected').focus();
								}
							} else {
								liSelected = li.eq(0).addClass('selected').focus();
							}
						} else if (e.which === 38) {
							if (liSelected) {
								liSelected.removeClass('selected');
								next = liSelected.prev();
								if (next.length > 0) {
									liSelected = next.addClass('selected').focus();
								} else {
									liSelected = li.last().addClass('selected').focus();
								}
							} else {
								liSelected = li.last().addClass('selected').focus();
							}
						}
						e.preventDefault();
						$("#cmppDrugNameTextID").val(liSelected.attr('aria-label'));
						$('label[for="cmppDrugNameTextID"]').addClass('active');
					}
	
					$('#cmppDrugNameTextID').removeClass('error');
					var drugSearchKeyword = $.trim($(this).val());
					if (drugSearchKeyword.length >= PharmacyResultSelfService.drugSearchMinLength && e.which != 40 && e.which != 38) {
						PharmacyResultSelfService.getAutoSuggestedDrugAuthDetails(drugSearchKeyword);
					}
				});
	
				$("#cmppDrugNameTextID, #cmppAutoSuggest").keydown(function (e) {
					if (e.which === 40 || e.which === 38) {
						e.preventDefault();
					}
				});
	
				/**
	    * Form handling and submission handling once the user click on the Compare Price button in the form
	    */
				$('#cmppSubmitId').on('click', function () {
					var validationSuccess = PharmacyResultSelfService.validateDrugForm();
					if (validationSuccess) {
						$("#cmppSubmitFormId").submit();
					} else {
						$('#div_drugNameAutoSuggestionsError').show();
						$('#cmppDrugNameTextID').addClass('error');
						$('#div_drugNameAutoSuggestionsError').addClass('error');
						var displayError = '';
						displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
						$('#div_drugNameAutoSuggestionsError').html(displayError);
						$('.cmppAutoSuggest').hide();
					}
				});
				/**
	    * Form handling and submission handling once the user press the Enter button in the text field blur
	    */
				$('#cmppDrugNameTextID').keypress(function (event) {
					if (event.which == PharmacyResultSelfService.EnterKeywordCode) {
						var validationSuccess = PharmacyResultSelfService.validateDrugForm();
						if (validationSuccess) {
							$("#cmppSubmitFormId").submit();
						} else {
							$('#div_drugNameAutoSuggestionsError').show();
							$('#cmppDrugNameTextID').addClass('error');
							$('#div_drugNameAutoSuggestionsError').addClass('error');
							var displayError = '';
							displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
							$('#div_drugNameAutoSuggestionsError').html(displayError);
							$('.cmppAutoSuggest').hide();
							event.preventDefault();
							return false;
						}
					}
				});
				/**
	    * 
	    */
				$('#cmppDrugNameTextID').focusin(function () {
					var drugSearchKeyword = $.trim($(this).val());
					if (drugSearchKeyword.length >= PharmacyResultSelfService.drugSearchMaxLength) {
						PharmacyResultSelfService.getAutoSuggestedDrugAuthDetails(drugSearchKeyword);
					}
				});
	
				$(document).mouseup(function (e) {
					var container = $("#compare-price-container");
					if (!container.is(e.target) && container.has(e.target).length === 0) {
						window.setTimeout(function () {
							$('.cmppAutoSuggest').hide();
							$('#cmppDrugNameTextID').removeClass('error');
							$('#div_drugNameAutoSuggestionsError').removeClass('error');
							$('#div_drugNameAutoSuggestionsError').hide();
						}, 300);
					}
				});
				/**
	    * 
	    */
				$('#cmppDrugNameTextID').on('input', function () {
					var drugSearchKeyword = $.trim($(this).val());
					if (drugSearchKeyword.length < PharmacyResultSelfService.drugSearchMaxLength) {
						$('#cmppAutoSuggest').hide();
						var displayError = '';
						$('#cmppDrugNameTextID').removeClass('error');
						$('#div_drugNameAutoSuggestionsError').html(displayError);
					}
				});
				$('#costcoModalView').on('click', function () {
					showMoreMap();
				});
				$('#ShowMore').on('click', function () {
					$('ul#costcoModalBodyData li:hidden').slice(0, 2).show();
					if ($('ul#costcoModalBodyData li').length == $('ul#costcoModalBodyData li:visible').length) {
						$('#ShowMore').hide();
					};
				});
				$('select#filter_brand option').on('change', function () {
					var text = $(this).text().replace(/ /g, '');
					if ($('select').width() < 1198 && text.length() === 26) {
						text = text.substring(0, 26) + '...';
						$(this).text(text);
					}
				});
			}
	
			if ($('.link-membership-pet-meds').length > 0) {
				COSTCO.LinkMembership.init();
			}
		});
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 24:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	* @title checkout_helper.js: Feature level module
	* @description Utility module associated with checkout
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var Checkout = {
			/**
	  * Default implementation of the done promise used by ajax_update_state.
	  * The data structure this function uses is defined in JSONLayout.jsp.
	  * Update the state of each html segment. This assumes that the
	  * property key maps to the id of the html segment to replace. Also,
	  * if there any errors defined on the response_obj.error,
	  * display them.
	  * @param  {String} data       The JSON returned as a string. Contains
	  *                             the encoded html that must be decoded
	  *                             and then is injected into the DOM.
	  * @param  {String} textStatus [description]
	  * @param  {String} jqXHR      [description]
	  * @param  {Object} options    The options object originally passed to
	  *                             ajax_update_state
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_done
	  */
			ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
				try {
					var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
					var defaultOptions = {
						ajax_replace_content: COSTCO.Checkout.ajax_replace_content,
						ajax_handle_errors: COSTCO.Checkout.ajax_handle_errors,
						ajax_update_post_done: function ajax_update_post_done() {},
						error_container: '',
						scrollToError: true
					};
					$('body').trigger('costco.ajax.content.update.start', response_obj);
					var mergedOptions = $.extend(true, {}, defaultOptions, options);
					// Inject New Html
					mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
					// Post Html Injection
					mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
					// Handle any Errors and perform cleanup
					mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
					$('body').trigger('costco.ajax.content.update.end', response_obj);
				} catch (e) {
					console.error(e);
				}
				console.log('ajax_update_default_done');
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_replace_content
	  */
			ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
				Object.keys(response_obj.payload.html).forEach(function (key) {
					var encoded_html = response_obj.payload.html[key];
					if (mergedOptions.replaceKey) {
						if (mergedOptions.replaceKey.original == key) {
							key = mergedOptions.replaceKey.replace;
						}
					}
					$('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
					console.log('ajax_replace_content' + key);
				});
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_handle_errors
	  */
			ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
				if ($('#isBDAppVar').val() == 'BD') {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
					} else {
						$('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
					}
				} else {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
						$('.error:not(select)').removeClass('critical-notification');
					} else {
						$('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
					}
	
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				var error_container = mergedOptions.error_container;
				if (Checkout.isReviewPage() || Checkout.isPaymentPage()) {
					if (typeof TokenGateway !== 'undefined') {
						TokenGateway.refreshGateway();
					}
					if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
						error_container = '#errquantity_application_';
						$('#errquantity_application_').addClass('critical-notification');
						$('#errquantity_application_').removeClass('error');
						$("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
	
						if ($('#errquantity_application_').html().trim() == '') {
							$('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
						}
					} else {
						if (typeof COSTCO.CreditCard !== 'undefined') {
							COSTCO.CreditCard.init();
						}
						if (typeof COSTCO.wallet !== 'undefined') {
							//wallet module is not used in USBD - all other allow
							if (wcs.storeId != '11301') {
								COSTCO.wallet.init();
							}
						}
						if (typeof COSTCO.CC !== 'undefined') {
							COSTCO.CC.init();
						}
					}
				}
				var input_container = mergedOptions.input_container;
				var application = response_obj.error.application || [];
				var exception = response_obj.error.exception || [];
				var error_html = '';
				if (exception.length > 0) {
					if (wcs.langId !== -25) {
						error_html += '<p>Sorry, we are experiencing technical issues. Please try again later.</p>';
					} else {
						error_html += '<p>Désolé, nous éprouvons des difficultés techniques. Veuillez réessayer plus tard.</p>';
					}
				}
				application.forEach(function (error_message) {
					error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
				});
				// if there is a redirect, store the error in sessionStorage and redirect user,
				// otherwise error will show in error container
				if (response_obj.error.redirect) {
					if (typeof sessionStorage != 'undefined') {
						sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
					}
					document.location.href = '/' + response_obj.error.redirect;
					return;
				}
				if (typeof error_container === 'string') {
					error_container = $(error_container);
				}
				if (input_container) {
					if (application.length + exception.length > 0) {
						$(input_container).addClass('error');
						$(input_container).attr('aria-invalid', 'true');
					} else {
						$(input_container).removeClass('error');
						$(input_container).attr('aria-invalid', 'false');
					}
				}
				if (error_container == '' || error_container.length == 0) {
					$('body').trigger('costco.ajax.content.update.sucess', response_obj);
					return;
				}
				error_container.children().remove();
				if (response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0) {
					$(error_container).html('');
					COSTCO.Checkout.showPaymentEditOption($('input[name=payMethodId]').val());
				}
				if (error_html.trim() != '') {
					error_container.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
					error_container.append(error_html);
					error_container.addClass('critical-notification');
					if (mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification) {
						error_container.removeClass('critical-notification');
					}
	
					// add quantity limit error at the item level for BD
					if ($('#isBDAppVar').val() == 'BD') {
						$('.order-item').each(function () {
							if ($(this).find('.itemPartNumberPurchased').html() == response_obj.error.itemNumber) {
								$(this).find('.critical-notification').append(error_html).removeClass('hide');
							}
						});
					}
	
					COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
				}
				// Add/remove class critical-notification for page-top error in Cart page
				if (error_container.attr('id') == 'errquantity_' && checkoutPage && checkoutPage == 'cart') {
					if (error_container.html().trim() != '') {
						error_container.addClass('critical-notification');
					} else {
						error_container.removeClass('critical-notification');
					}
				}
				if ($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != '') {
					if (!COSTCO.OrderSummary.isAllPaidByCashCard()) {
						COSTCO.Checkout.showPaymentEditSection($('input[name=payMethodId]').val());
					} else {
						$('#errquantity_application_').html('');
						$('#errquantity_application_').removeClass('critical-notification');
						$('#errquantity_application_').addClass('error');
					}
					COSTCO.CC.init();
				} else if ($('#errquantity_application_').length > 0) {
					$('#errquantity_application_').removeClass('critical-notification');
					$('#errquantity_application_').addClass('error');
					//This will do the real work - I have no idea what the above code does.
					//This will place error messages in-line
				} else if ($('#isBDAppVar').val() == 'BD') {
					COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
					if ($("#contractErrContainer").length > 0) {
						error_container.addClass('hide');
						if (!$("#contractErrContainer").is(':visible')) $("#contractErrContainer").removeClass('hide');
					} else {
						error_container.removeClass('hide');
					}
				}
				if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
					$('body').trigger('costco.ajax.content.update.error', response_obj);
					$('body, html').animate({
						scrollTop: $(error_container).offset().top - 30
					}, 800);
				}
			},
	
			/**
	  * A generic function to make ajax requests. The only difference being
	  * that this function sets a default done promise that injects html
	  * into the DOM with the response data. Pass done, fail, and always
	  * functions to the options object to be called in each respective promise.
	  * @param  {Object} options Object containing options to pass to $.ajax
	  *                          and functions to call within $.ajax promises.
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_state
	  */
			ajax_update_state: function ajax_update_state(options, page) {
				// Prevent code breaking if checkoutPage is undefined.
				//let checkoutPage = typeof window.checkoutPage == 'undefined' ? false : window.checkoutPage;
				$('.order-ajax').addClass('ajax-busy');
				var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
				if (options.page || checkoutPageName) {
					options.url = COSTCO.util.makeUrl(options.url, {
						'checkoutPage': options.page || checkoutPageName
					});
				}
				if (!options.done) {
					options.done = COSTCO.Checkout.ajax_update_default_done;
				}
				if (!options.always) {
					options.always = COSTCO.Checkout.ajax_update_default_always(options.inputContainer);
				}
				COSTCO.util.ajax(options);
			},
	
			/**
	  * Extracting default function out so we can perfom this and something else
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_always
	  */
			ajax_update_default_always: function ajax_update_default_always(inputContainer) {
				$('.order-ajax').removeClass('ajax-busy');
				COSTCO.Checkout.validator = undefined;
				// ALM 54928 Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				// Create a function to focus back to the original input after
				// the ajax call is done
				// This will only be done only if there input is defined in the option payload
				// ALM 54928: Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				if (inputContainer) {
					var focusInput = $(inputContainer);
					if (focusInput.length > 0) {
						// If we have the id then lets use it
						if (focusInput[0].id) {
							console.log(focusInput[0].id);
							$('#' + focusInput[0].id).focus();
						} else {
							console.log('Working for it');
							// Ok no id so now we have to do work
							if (focusInput[0].nodeName == 'INPUT') {
								if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
									$('input:checked[name="' + focusInput.attr('name') + '"]').focus();
								}
							}
						}
					}
				}
			},
	
			/**
	  * Displays the error message stored in sessionStorage from the previous page
	  * where error was sent to client, but a redirect needed to happen
	  */
			display_error_after_redirect: function display_error_after_redirect() {
				if (typeof sessionStorage != 'undefined' && sessionStorage.getItem('errorMessage')) {
					var $container = $('#progress-meter-row').children().last();
					$container.addClass('error');
					$container.append(sessionStorage.getItem('errorMessage'));
					sessionStorage.removeItem('errorMessage');
				}
			},
	
			/**
	  * Util to give an interactive character count down
	  * @param  {ojbect} label    pass the jquery obj where you want the
	  *                           countdown to reflect
	  * @param  {object} textarea pass a 'text' input
	  *                           (input[type='text'],textarea) to count
	  * @return {void}
	  */
			character_count: function character_count(label, textarea) {
				if ($(label).length > 0 && $(textarea).length > 0) {
					var updateLabelCount = function updateLabelCount(textarea, label) {
						var count = $(textarea).val().length;
						$(label).text(max - count);
					};
	
					var max = parseInt($(textarea).attr('maxlength'));
					$(label).text(max - $(textarea).val().length);
					$(textarea).unbind('keyup').on('keyup', function () {
						updateLabelCount(this, label);
					});
					$(textarea).unbind('change').on('change', function () {
						updateLabelCount(this, label);
					});
				}
			},
	
			getAuthToken: function getAuthToken() {
				return $('[name=authToken]').first().val();
			},
	
			show_busy_indicator: function show_busy_indicator() {
				$('.order-ajax').addClass('ajax-busy');
			},
	
			remove_busy_indicator: function remove_busy_indicator() {
				$('.order-ajax').removeClass('ajax-busy');
			},
	
			/**
	  * If PAD is the only choice in div.delivery-option-radios, PAD is required.
	  * Else it ain't.
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean} Is PAD required as a shipping method for this item.
	  */
			is_pad_required: function is_pad_required(delivery_radios) {
				var $radio_containers = $(delivery_radios).children();
				return $radio_containers.length === 1 && $radio_containers.first().hasClass('pad');
			},
	
			/**
	  * Is a PAD delivery option radio selected?
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean}                 Is the PAD radio selected?
	  */
			is_pad_selected: function is_pad_selected(delivery_radios) {
				var isSelected = false;
				var $pad_input = $(delivery_radios).find('.pad input[type=radio]');
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
					var $padWithoutNextDay = $(delivery_radios).find('.individualShipBlock, .individualPharmacyShipModes');
					if ($(delivery_radios).find(".grocery-header-text").length === 0 && $(delivery_radios).find(".frozen-header-text").length === 0) {
						if ($padWithoutNextDay.length === 0) {
							$(delivery_radios).find(".selection-box-v2.pad").attr("checked");
							isSelected = true;
						} else {
							isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
						}
					}
				} else {
					isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
				}
				return isSelected;
			},
	
			/**
	  * Clean inputs with quantity value unit
	  */
			clear_form: function clear_form() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					var inputs = $('input[name^=quantity]');
					if (inputs) {
						inputs.each(function () {
							var parent = $(this).parent('div');
							parent.removeClass('error');
						});
					}
				}
			},
			/**
	  * Generic validator instance
	  * @type $.validator
	  */
			validator: undefined,
	
			/**
	  * This function is used for dynamic form validation. Its meant to be
	  * wrapped in a decorator and configured appropriately. (See how
	  * orderitems.js uses it). Everything keys off of options_obj.rule. If
	  * a rule is supplied, we're matching that rule with a single dynamic input.
	  * Otherwise, we want to validate multiple, dynamic inputs. We pass a
	  * options_obj.validate_inputs function(See orderitem.js example) that
	  * applies the rules we want. Finally, if we're valid, execute the supplied
	  * callback
	  * @param  {object} options_obj The object with the following properties:
	  *                              {
	  	*                                form: <The form we're validating>,
	  	*                                input: <optional: input to validate>,
	  	*                                validate_inputs: <The fn to add N number
	  	*                                  of rules>,
	  	*                                rule: <optional: the object that represents
	  	*                                  the rule to validate with provided input>,
	  	*                                rules_config_obj: <All of the rules to
	  	*                                  potentially pass to $.fn.validator>,
	  	*                                callback: <The function to pass on
	  	*                                  successful validation>
	  	*                              }
	  * @return {void}
	  */
			_dynamic_validate: function _dynamic_validate(options_obj) {
				var self = COSTCO.Checkout;
				var $form = options_obj.form;
				var $input = options_obj.input;
				var validate_inputs = options_obj.validate_inputs;
				var rule = options_obj.rule;
				var rules_config_obj = options_obj.rules_config_obj;
				var callback = options_obj.callback;
				//callbackParams is used in case callback function has parameters
				var callbackParams = options_obj.callbackParams;
				var options = {
					focusInvalid: false,
					errorElement: 'span'
				};
				var errorPlacement = options_obj.errorPlacement;
				if (self.validator && rule != 'quantity') {
					$form.destroyValidator(self.validator);
					COSTCO.Checkout.clear_form();
				}
				// If we're not validating a single input, we want to call the invalid
				// handler so when we throw an error we scroll to where that error is.
				if (!rule) {
					options.invalidHandler = COSTCO.util.invalid_handler;
				}
				self.validator = $form.validate(options);
				if (rule) {
					// We want a specific rule bound on the input.
					// If we're being called as an inline event handler on an input, we good, otherwise
					// use the data-id attribute of the calling DOM element to get the input.
					var $input = $input.prop('tagName') === 'INPUT' || $input.prop('tagName') === 'SELECT' ? $input : $('#' + $input.data('id'));
					$input.rules('add', rules_config_obj[rule]);
					if (!(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE)) {
						if ($('#isBDAppVar').val() == 'BD' && rule == 'quantity') {
							self.validator.settings.errorClass = self.validator.settings.errorClass + ' error-qty-increment';
						}
					}
				} else {
					// Case where we have mulitple dynamic inputs to validate
					if (validate_inputs) validate_inputs(rules_config_obj);
				}
				if (errorPlacement) {
					self.validator.settings.errorPlacement = errorPlacement;
				}
				// $.validator.form triggers form validation programmatically
				// If we're a valid form, execute the callback.
				if (self.validator.form()) {
					if (callback) {
						if (callbackParams !== undefined && callbackParams.length > 0) {
							callback(callbackParams);
						} else {
							callback();
						}
					}
				}
			},
	
			editMyAccount: function editMyAccount(view) {
				var path = "/AccountInformationView?langId=" + wcs.langId + "&storeId=" + wcs.storeId + "&catalogId=" + wcs.catalogId + "&crmSpecificView=" + view;
				window.location.href = path;
			},
	
			/**
	  * This is the inline event handler for membership application item.
	  * It needs to redirect back to the application page.
	  * @param  {[type]} partNumber  [description]
	  * @param  {[type]} orderItemId [description]
	  * @param  {[type]} orderId     [description]
	  * @return {void}
	  */
			editApplication: function editApplication(partNumber, orderItemId, orderId) {
				var path = '';
				try {
					$.cookie('APPLICATION_TRACKING_COOKIE', null, {
						path: '/'
					});
				} catch (e) {}
				if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
					path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				} else {
					path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				}
				$.cookie('APPLICATION_TRACKING_COOKIE', orderItemId);
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					path += '&orderId=' + orderId;
				}
				window.location.href = path;
			},
	
			/**
	  * Opens 'Remove Memebrship/Renewal Warning Modal' dialog modal.
	  * @return {void}
	  */
			openRemoveWarningModal: function openRemoveWarningModal(isRenew, orderItemId) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item(orderItemId);
					}
				});
			},
	
			openRemoveWarningModal_v2: function openRemoveWarningModal_v2(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
					}
				});
			},
	
			deletePaymentInstructionsForOrder: function deletePaymentInstructionsForOrder() {
				return new Promise(function (resolve, reject) {
					if (Checkout.isCheckoutPage()) {
						// if we're on the checkout page
						var currentOrderId = $('INPUT[name="orderId"]').val();
						COSTCO.util.ajax({
							url: '/AjaxDeletePaymentInstructionsForOrder',
							method: 'POST',
							dataType: 'json',
							data: {
								orderId: currentOrderId
							},
							success: function success(result) {
								// if no xcreditcard id, clear everything in the form. Else, clear the piId and populate the xCreditCardId in the form
								if (result.xcreditCardId.length === 0) {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('#account').length > 0) {
										$('#account').val('');
									}
									if ($('#cc_expiry_date').length > 0) {
										$('#cc_expiry_date').val('');
									}
									if ($('#cc_nameoncard').length > 0) {
										$('#cc_nameoncard').val('');
									}
								} else {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('[name="xCreditCardId"]').length > 0) {
										$('[name="xCreditCardId"]').val(result.xcreditCardId);
									}
								}
	
								console.log('Deleted payment instructions for order ' + currentOrderId);
								resolve();
							},
							fail: function fail(error) {
								console.error('Error deleting payment instructions for order ' + currentOrderId);
								resolve();
							}
						});
					} else {
						// if we're not on the checkout page, do nothing
						resolve();
					}
				});
			},
	
			showPaymentEditOption: function showPaymentEditOption(payType, skipCreateToken) {
				if (payType == 'ACH' && hasCashCard) {
					COSTCO.CC.removeCashCard($('#remove-cash-card-link'));
				}
				if (/^(Check|LineOfCredit)$/i.test(payType)) {
					Checkout.showPaymentEditSection(payType);
				} else {
					Checkout.deletePaymentInstructionsForOrder().then(function () {
						COSTCO.Checkout.moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay();
						if (undefined == skipCreateToken) {
							createTokenSessionId().then(function () {
								Checkout.showPaymentEditSection(payType);
							});
						}
					});
				}
			},
	
			showPaymentEditSection: function showPaymentEditSection(payType) {
				$('#payment-method-radio-buttons').removeClass('hide');
				$('#cod-ach-acr-payment').removeClass('hide');
				$('#cc-payment-block-title').removeClass('hide');
				$('#cc-payment-block').removeClass('hide');
				$('#credit-card-address-block').removeClass('hide');
				$('#cc-payment-address-block').removeClass('hide');
				$('#credit-card-block').removeClass('hide');
				$('#wallet-block').removeClass('hide');
				$('#credit-card-info-container').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				$('#single-page-checkout #cc-payment-block').attr('do-not-show', 'false');
				$('.payment-method-change').addClass('hide');
				$('#applepay-payment-block').addClass('hide');
				$('#applepay-block-form').removeClass('display');
				$('#applepay-info-container').addClass('hide');
				$('#place-order-button-regular').removeAttr('do-not-show');
				$('#place-order-button-applepay').attr('do-not-show', 'true');
				$('#place-order-button-regular').removeClass('hide');
				$('#place-order-button-applepay').addClass('hide');
				if (COSTCO.Checkout.displayAllPayments()) {
					$('#credit-card-block-review').addClass('hide');
					$('input[id=usedPayMethod]').val('');
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					$('#wallet-payment-address-form').addClass('hide');
					$('#payment-address-form').removeClass('hide');
					$('#payment-address-form .address-change-link-B').removeClass('hide');
					$('input[id=appliedPayMethod]').val('');
					$('input[id=isApplePaySheetSubmitted]').val('');
					$('input[id=unifiedPaymentType]').val('');
				}
				if ($('#isBDAppVar').val() == 'BD') {
	
					if (COSTCO.util.isNdEnabled()) {
						$('#ach-block').removeClass('hide');
					} else if (!COSTCO.util.isExternalCarrierShipmode()) {
						$('#check-del-block').removeClass('hide');
						$('#ach-block').removeClass('hide');
						$('#acc-receiv-block').removeClass('hide');
					}
	
					var paymentType = $('#ordPayInsVal').length > 0 ? $('#ordPayInsVal').val() : payType;
					if (paymentType == 'Check') {
						COSTCO.wallet.showCheckOnDeliverySection();
					} else if (paymentType == 'ACH') {
						COSTCO.wallet.showACHSection();
					} else if (paymentType == 'LineOfCredit') {
						COSTCO.wallet.showAcctReceivableSection();
					} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
						$('#wallet-info-div').addClass('hide');
						$('#wallet-change-link').addClass('hide');
						if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
							COSTCO.wallet.showMasterpassSection();
						} else {
							COSTCO.wallet.disableUseExistingWallet();
							COSTCO.wallet.showVisaSection();
						}
					} else {
						COSTCO.wallet.showCCSection();
						Checkout.reValidateCVV();
					}
				} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
					$('#wallet-info-div').addClass('hide');
					$('#wallet-change-link').addClass('hide');
					if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
						COSTCO.wallet.showMasterpassSection();
					} else {
						COSTCO.wallet.disableUseExistingWallet();
						COSTCO.wallet.showVisaSection();
					}
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
				} else {
					COSTCO.wallet.showCCSection();
					Checkout.reValidateCVV();
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('credit card');
				}
				$('#auto-renew-div').appendTo($('#save_CC').parent().parent());
				$('#auto-renew-div').removeClass('mt-16');
				$('#auto-renew-div').addClass('mt-5');
				$('#auto-renew-div').addClass('mb-16');
				$('#autorenew-invalid-saved-card-div').addClass('hide');
				return false;
			},
	
			hidePaymentEditSection: function hidePaymentEditSection() {
				$('#payment-method-radio-buttons').addClass('hide');
				$('#cod-ach-acr-payment').addClass('hide');
				$('#cc-payment-block').addClass('hide');
				$('#credit-card-block').addClass('hide');
				$('#credit-card-address-block').addClass('hide');
				$('#cc-payment-address-block').addClass('hide');
				$('#wallet-block').addClass('hide');
				if ($('#isBDAppVar').val() == 'BD') {
					$('#check-del-block').addClass('hide');
					$('#ach-block').addClass('hide');
					$('#acc-receiv-block').addClass('hide');
				}
			},
	
			clickToPayWasTriggered: function clickToPayWasTriggered() {
				var value = sessionStorage.getItem('CLICK_TO_PAY_TRIGGERED');
				return value ? true : false;
			},
	
			removeClickToPayTriggered: function removeClickToPayTriggered() {
				sessionStorage.removeItem('CLICK_TO_PAY_TRIGGERED');
			},
	
			setClickToPayTriggered: function setClickToPayTriggered() {
				sessionStorage.setItem('CLICK_TO_PAY_TRIGGERED', true);
			},
	
			moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay: function moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay() {
				if (COSTCO.Checkout.clickToPayWasTriggered()) {
					var btn = $('#orderSummaryCheckoutButton');
					if (btn.length) {
						var currentStepNumber = parseInt(btn.attr('current-step-number')),
						    finalStepNumber = CHECKOUTSTEPS.length;
						// if we're on the last checkout step
						if (currentStepNumber > 1 && currentStepNumber == finalStepNumber) {
							var previousStepIndex = currentStepNumber - 2,
							    previousStepNumber = currentStepNumber - 1;
							btn.val(CHECKOUTSTEPS[previousStepIndex].text).attr('onclick', 'COSTCO.OrderSummary.checkoutSteps.submitCheckoutStep(' + previousStepNumber + ')');
						}
					}
				}
				COSTCO.Checkout.removeClickToPayTriggered();
			},
	
			updateCheckoutForm: function updateCheckoutForm() {
				var val = this.checked ? 'on' : 'off';
				$('#isSavedPaymentAutoRenew').prop('value', val);
			},
	
			isCheckoutPage: function isCheckoutPage() {
				return $('#CheckoutPaymentForm').length ? true : false;
			},
	
			isCartPage: function isCartPage() {
				return $('#cart').length > 0;
			},
	
			isReviewPage: function isReviewPage() {
				var isReviewPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					isReviewPage = true;
				}
				return isReviewPage;
			},
	
			isPaymentPage: function isPaymentPage() {
				var isPaymentPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutPaymentView')) {
					isPaymentPage = true;
				}
				return isPaymentPage;
			},
	
			reValidateCVV: function reValidateCVV() {
				if ($('#cc_expiry_date').val() != '') {
					COSTCO.CreditCard.validate.creditCardForm();
					$("label[for='cc_cvc_validator']").text(messages.CVV_REENTER);
				} else {
					$('#save_CC').prop('checked', false);
				}
			},
			toggleCartAccordion: function toggleCartAccordion(orderItemId) {
				if ($('#cart-accordion-header-1-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).hide();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).show();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-" + orderItemId + "'></i>");
				}
			},
	
			membershipAutoRenewOptionOptedIn: function membershipAutoRenewOptionOptedIn() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('true');
				$('#wallet-block').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				if ($('#credit-card-info-container').length == 0) {
					$('#wallet-info-div').addClass('hide');
					$('#credit-card-block').removeClass('hide');
				}
				document.getElementById('credit-card-block').scrollIntoView({ behavior: 'smooth', block: 'center' });
			},
	
			membershipAutoRenewOptionOptedOut: function membershipAutoRenewOptionOptedOut() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('false');
				if (!$('#wallet-info-div').length > 0) {
					$('#wallet-block').removeClass('hide');
				}
				$('#CheckoutPaymentForm').validate().resetForm();
				$('#account').removeClass('error-credit-card');
				$('#cc_cvc').removeClass('error-credit-card');
				$('#account_validator_err_msg').html('');
				$('#cc_cvc_err_msg').html('');
				$('#cc_membership_renew_error').removeClass('critical-notification');
				$('#cc_membership_renew_error').addClass('alert-notification');
			},
	
			pageRefreshForToken: function pageRefreshForToken() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				digitalDataEvents.push({ nav: "Checkout Flow | refresh your page" });
			},
	
			toggleCartAccordionMobile: function toggleCartAccordionMobile(orderItemId) {
				if ($('#cart-accordion-header-2-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).hide();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-m-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).show();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-m-" + orderItemId + "'></i>");
				}
			},
	
			/**
	  * Helper function to recompile & reload all checkout sections. Performed by ajax-modular
	  * call to '/order-prepare' without additional request parameters.
	  * @return {object} Deferred
	  */
			ajaxRefreshAllCheckoutSections: function ajaxRefreshAllCheckoutSections() {
				var deferred = $.Deferred();
				COSTCO.CreditCard.initComplete = false;
				COSTCO.AjaxModular.ajax_update_state({
					url: '/order-prepare',
					always: function always(data, textStatus, jqXHR, options) {
						deferred.resolve();
					}
				});
				return deferred.promise();
			},
	
			addScreenReaderAnnouncement: function addScreenReaderAnnouncement(adaMessage) {
				var adaMessageDiv = $('#screen-reader-announcement');
				if (adaMessageDiv.length > 0) {
					setTimeout(function () {
						adaMessageDiv.html(adaMessage);
					}, 1000);
				}
			},
			displayAllPayments: function displayAllPayments() {
				return costcoStoreFeatures.DISPLAY_ALL_PAYMENTS;
			},
			usedPayment: function usedPayment() {
				return $('input[id=usedPayMethod]').length > 0 ? $('input[id=usedPayMethod]').val() : "";
			},
			resetCheckoutPaymentFields: function resetCheckoutPaymentFields(payType) {
				$('#account').val("");
				$('#cc_cvc').val("");
				$('#cc_expiry_date').val("");
				$('#cc_nameoncard').val("");
				TokenGateway.focusField = "card.number";
				$('#cc_cvc_err_msg').addClass('hide');
				$.cookie('tkSession', 'false', { path: '/' });
				createTokenSessionId().then(function () {
					Checkout.showPaymentEditSection(payType);
				});
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.Checkout = Checkout;
		return Checkout;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 27:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title link-membership.js: Sub-module for Product Details page
	 * @description This sub-module is used to handle membership validation.
	 * @dependency checkout_helper.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (checkoutHelper) {
	  var LinkMembership = {
	
	    /**
	     * Constants.
	     */
	    constants: {
	      PRIMARY_VALIDATION_FORM_ID: '#membership-primary-validation-form',
	      PRIMARY_VALIDATION_FORM_NAME: 'membershipPrimaryValidationForm',
	      SECONDARY_VALIDATION_FORM_ID: '#membership-secondary-validation-form',
	      ERROR_PLACEHOLDER_ID: '#error-placeholder',
	      AJAX_LOADER_ID: '#link-membership-loader',
	      SECONDARY_VALIDATION_VIEW: '/MembershipSecondaryValidationView',
	      CANCELED_MEMBERSHIP_VIEW: '/CanceledMembershipView'
	    },
	
	    /**
	     * Object that holds useful membership data.
	     */
	    memberData: {
	      number: ''
	    },
	
	    /**
	     * Initialization function.
	     */
	    init: function init() {
	      // 'Link Membership' button visibility is toggled in CMath.init() which executes prior to this call.
	      if ($('#link-membership, #link-membership-v2, .link-membership-btn, .link-membership-pet-meds').is(':visible')) {
	        $('#link-membership, #link-membership-v2, .link-membership-btn, #link-membership-for-price').unbind('click').click(function () {
	          COSTCO.LinkMembership.openLinkMembershipModal();
	        });
	
	        COSTCO.LinkMembership.populateMemberData();
	        COSTCO.LinkMembership.addValidationRules();
	      }
	      if ($('#ProductForm [name=purchase-membership]').is(':visible')) {
	        $('#ProductForm [name=purchase-membership]').unbind('click').click(function () {
	          COSTCO.LinkMembership.purchaseMembershipButtonClick();
	        });
	      }
	
	      console.log('Link Membership sub-module initialized.');
	    },
	
	    /**
	     * Populates this.memberData using the membershipNumber derived from
	     * wcMember persistent cookie.
	     */
	    populateMemberData: function populateMemberData() {
	      this.memberData.number = COSTCO.util.getMemberCookie().membershipNumber;
	    },
	
	    /**
	     * Mask employee start date
	     */
	    maskStartDateInput: function maskStartDateInput() {
	      $('#employeeStartDate').mask('00/00', {
	        placeholder: 'MM/YY'
	      });
	    },
	
	    /**
	     * Opens 'Link Membership for Price' dialog modal.
	     */
	
	    openLinkMembershipModal: function openLinkMembershipModal(title) {
	
	      var modalTitle = typeof title === 'undefined' ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Title : title;
	
	      var bypassEnabled = typeof memberValidationBypassFeatureEnabled !== "undefined" && memberValidationBypassFeatureEnabled === true;
	      var modalSettings = {
	        dialogclasses: 'link-membership-modal',
	
	        title: bypassEnabled ? messages.RWD_ADD_MEMBERSHIP_NUMBER : modalTitle,
	        body: COSTCO.util.tmpl('tmpl_membership_validation_pdp', {
	          infoText: bypassEnabled ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText_ALT : messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText,
	          membershipNumber: COSTCO.LinkMembership.memberData.number
	        }),
	
	        primary: bypassEnabled ? messages.RWD_ADD_MEMBERSHIP_NUMBER : messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Continue_ButtonText,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: this.performPrimaryValidation,
	        preventClose: false,
	        onshown: function onshown() {
	          $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
	          COSTCO.util.maskMembershipInput();
	          $('.co-help').popover();
	        },
	        onclose: function onclose() {}
	      };
	
	      COSTCO.dialog.showModal(modalSettings);
	    },
	    /**
	     * Executes logic on Purchase Membership button click on PDP page.
	     */
	    purchaseMembershipButtonClick: function purchaseMembershipButtonClick() {
	      if ($.cookie('cartCountCookie') > 0) {
	        window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	      } else {
	        window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	      }
	    },
	    /**
	     * Validation rules for the inputs associated with creating an account.
	     */
	    addValidationRules: function addValidationRules() {
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	    },
	
	    /**
	     * Validates the primary validation form.
	     * @param {Object} $primaryValidationForm - Form to be validated.
	     */
	    validatePrimaryValidationForm: function validatePrimaryValidationForm($primaryValidationForm) {
	      $primaryValidationForm.validate({
	
	        ignoreTitle: true,
	
	        rules: {
	          membershipId: {
	            required: true,
	            costcoMembership: true
	          },
	          lastName: {
	            // Last name is not required, i.e. for internal membership
	            // required: true,
	          }
	        },
	
	        messages: {
	          membershipId: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          lastName: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        },
	        highlight: COSTCO.util.highlightWithErrorLabel,
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	    },
	
	    /**
	     * Performs primary validation of entered data via calling Ajax Modular command.
	     */
	    performPrimaryValidation: function performPrimaryValidation() {
	      var $primaryValidationForm = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID);
	
	      COSTCO.LinkMembership.validatePrimaryValidationForm($primaryValidationForm);
	
	      if ($primaryValidationForm.valid()) {
	        COSTCO.LinkMembership.clearErrors();
	        COSTCO.LinkMembership.ajaxLoader.on();
	        checkoutHelper.ajax_update_state({
	          method: 'POST',
	          url: '/AjaxMembershipPrimaryValidationCmd',
	          data: $primaryValidationForm.serialize(),
	          dataType: 'json',
	          done: function done(data, textStatus, jqXHR, options) {
	            // COSTCO.LinkMembership.clearErrors();
	            COSTCO.LinkMembership.ajaxLoader.off();
	            if (data.payload.data.status == 'success') {
	              COSTCO.LinkMembership.memberData.number = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID + ' :input[name=membershipId]').val().trim();
	              if (data.payload.data.validationCompleted) {
	                COSTCO.dialog.close();
	                location.reload();
	              } else {
	                checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);
	                COSTCO.LinkMembership.maskStartDateInput();
	                $('#costcoModalBtn2').html(messages.LINK_MEMBERSHIP_BUTTON);
	                $('#costcoModalBtn2').unbind('click').bind('click', COSTCO.LinkMembership.performSecondaryValidation);
	                if ($('#error-placeholder').data('status') == 'undetermined') {
	                  $('#costcoModalBtn2').unbind('click');
	                  $('#costcoModalBtn2').prop('disabled', true);
	                }
	              }
	            } else if (data.error.application.length > 0) {
	              var errorCode = data.payload.data.errorCode;
	              // Expired Membership
	              if (errorCode == 'E53') {
	                window.location.href = LinkMembership.constants.SECONDARY_VALIDATION_VIEW;
	                // Canceled Membership
	              } else if (errorCode == 'E54') {
	                var canceledMembershipNumber = data.payload.data.membershipId ? data.payload.data.membershipId : '';
	                var membershipStatusReason = data.payload.data.membershipStatusReason ? data.payload.data.membershipStatusReason : '';
	                var membership_membershipType = data.payload.data.membership_membershipType ? data.payload.data.membership_membershipType : '';
	                var isLostOrStolenCard = data.payload.data.isLostOrStolenCard ? data.payload.data.isLostOrStolenCard : '';
	                $form = $('form[name=' + LinkMembership.constants.PRIMARY_VALIDATION_FORM_NAME + ']');
	                $form.append('<input type="hidden" name="canceledMembershipNumber" value="' + canceledMembershipNumber + '">');
	                $form.append('<input type="hidden" name="membershipStatusReason" value="' + membershipStatusReason + '">');
	                $form.append('<input type="hidden" name="membership_membershipType" value="' + membership_membershipType + '">');
	                $form.append('<input type="hidden" name="isLostOrStolenCard" value="' + isLostOrStolenCard + '">');
	                $form.append('<input type="hidden" name="isReturningUser" value="true">');
	                $form.attr('action', LinkMembership.constants.CANCELED_MEMBERSHIP_VIEW);
	                $form.submit();
	              } else {
	                // Override this particular error message with the post-lockdown one; Remove as redundant in post-lockdown phase.
	                if (errorCode == 'E07') {
	                  data.error.application = [];
	                  data.error.application.push(messages._ERR_MEMBERSHIP_PRIMARY_VALIDATION_MEMBERSHIP_ID_POSTLOCKDOWN);
	                }
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, data.error.application, false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	                COSTCO.LinkMembership.markErrorFields(errorCode);
	              }
	            } else {
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	              console.error('Unexpected error occurred.');
	            }
	          },
	          always: function always() {
	            COSTCO.LinkMembership.ajaxLoader.off();
	            $('.order-ajax').removeClass('ajax-busy');
	          }
	        });
	      }
	    },
	
	    /**
	     * Performs secondary validation of entered data via calling Ajax Modular command.
	     */
	    performSecondaryValidation: function performSecondaryValidation() {
	      var $secondaryValidationForm = $(COSTCO.LinkMembership.constants.SECONDARY_VALIDATION_FORM_ID);
	      var action = $secondaryValidationForm.find('input[name=action]').val();
	      // If we're validating the employee primary first and last name, we set
	      // the users answer to a combination of these with a pipe.
	      if (action == 'employee_first_last_name') {
	        var firstName = $secondaryValidationForm.find('[name="usersFirstNameAnswer"]').val();
	        var lastName = $secondaryValidationForm.find('[name="usersLastNameAnswer"]').val();
	        $('#usersAnswer').val(firstName + '|' + lastName);
	      }
	
	      COSTCO.LinkMembership.ajaxLoader.on();
	
	      checkoutHelper.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxMembershipSecondaryValidationCmd',
	        data: $secondaryValidationForm.serialize(),
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.LinkMembership.ajaxLoader.off();
	          COSTCO.LinkMembership.clearErrors();
	          if (data.status == 'success') {
	            COSTCO.dialog.close();
	            location.reload();
	          } else if (data.message) {
	            // TODO: Is there a better way to handle '&lt;' and '&gt;' from response?
	            data.message = data.message.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	          } else {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	            console.error('Unexpected error occurred.');
	          }
	        },
	        always: function always() {
	          COSTCO.LinkMembership.ajaxLoader.off();
	          $('.order-ajax').removeClass('ajax-busy');
	        }
	      });
	    },
	
	    /**
	     * Marks input fields with class 'validation-error' depending on error code.
	     * @param {string} errorCode
	     */
	    markErrorFields: function markErrorFields(errorCode) {
	      if (['E01', 'E02', 'E03', 'E04', 'E07', 'E51'].indexOf(errorCode) > -1) {
	        $('input[name=membershipId]').addClass('validation-error');
	      }
	
	      if (['E01', 'E02', 'E03', 'E52'].indexOf(errorCode) > -1) {
	        $('input[name=lastName]').addClass('validation-error');
	      }
	
	      if (errorCode == 'unknown') {
	        console.error('Uknnown error code.');
	      }
	
	      $('input.validation-error:first').focus();
	    },
	
	    /**
	     * Clears error notification box and removes validation-error class from input fields.
	     */
	    clearErrors: function clearErrors() {
	      COSTCO.util.notification.clearNotification(COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	      $('input.validation-error').removeClass('validation-error');
	    },
	
	    /**
	     * Turn AJAX loader on/off and disable/enable clicking appropriately.
	     */
	    ajaxLoader: {
	      on: function on() {
	        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).show();
	        $('body').css('pointer-events', 'none');
	      },
	      off: function off() {
	        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).hide();
	        $('body').css('pointer-events', 'auto');
	      }
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.LinkMembership = LinkMembership;
	
	  return LinkMembership;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 98:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var Social = {
	
			shareWindow: function shareWindow(vendor) {
				var canonical = encodeURIComponent($('link[rel=canonical]').attr('href')),
				    desc = encodeURIComponent($('head title').text()),
				    media = encodeURIComponent($('meta[property=og\\:image]').attr('content'));
				if (vendor == 'facebook') {
					if (!COSTCO.whiteList.isOnWhiteList('"facebook.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://www.facebook.com/sharer/sharer.php?u=' + canonical + '&t=' + desc, '', 'left=0,top=0,width=626,height=436,toolbar=1,location=0,resizable=1,scrollbars=1');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://www.facebook.com/sharer/sharer.php?u=' + canonical + '&t=' + desc, '', 'left=0,top=0,width=626,height=436,toolbar=1,location=0,resizable=1,scrollbars=1');
					};
				} else if (vendor == 'twitter') {
					if (!COSTCO.whiteList.isOnWhiteList('"twitter.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://twitter.com/intent/tweet?url=' + canonical, '', 'left=0,top=0,width=795,height=700,toolbar=1,location=0,resizable=1,scrollbars=1');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://twitter.com/intent/tweet?text=' + desc + '&url=' + canonical, '', 'left=0,top=0,width=795,height=700,toolbar=1,location=0,resizable=1,scrollbars=1');
					};
				} else if (vendor == 'pinterest') {
					if (!COSTCO.whiteList.isOnWhiteList('"pinterest.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://www.pinterest.com/pin/create/button/?url=' + canonical + '&media=' + media + '&description=' + desc, '', 'left=0,top=0,width=700,height=600,toolbar=1,location=0,resizable=1,scrollbars=1');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://www.pinterest.com/pin/create/button/?url=' + canonical + '&media=' + media + '&description=' + desc, '', 'left=0,top=0,width=700,height=600,toolbar=1,location=0,resizable=1,scrollbars=1');
					};
				} else if (vendor == 'google') {
					if (!COSTCO.whiteList.isOnWhiteList('"google.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://plus.google.com/share?url=' + canonical, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://plus.google.com/share?url=' + canonical, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
					};
				}
			}
	
		}; //End Vendor object
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.Social = Social;
	
		return Social;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }

/******/ });


// WEBPACK FOOTER //
// pharmacyresultsselfservice.module.min.js